<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="0">
          <el-step
            :title="
              transportTypeCode == 'KY'
                ? $t('i18n_Air_Freight_Information')
                : transportTypeCode == 'HY'
                ? $t('i18n_ocean_freight_information')
                : transportTypeCode == 'LY'
                ? $t('i18n_land_transportation_information')
                : ''
            "
          ></el-step>
          <el-step :title="$t('i18n_Value_added_service')"></el-step>
          <el-step :title="$t('i18n_shipping_information')"></el-step>
          <el-step :title="$t('i18n_confirm_order')"></el-step>
          <el-step :title="$t('i18n_order_completed')"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div class="wrap_l">
        <!-- ---送货上门--- -->
        <div class="Item_list">
          <div class="cangkutit" style="margin-right: 50px">
            {{ fromFABck.namec }}
          </div>
          <div class="cangkutit" style="margin-right: 50px">
            <img v-show="transportTypeCode=='KY'" style="width: 60px"
            src=../../../static/images/KY.png alt="" /> <img
            v-show="transportTypeCode=='HY'" style="width: 60px"
            src=../../../static/images/HY.png alt="" /> <img
            v-show="transportTypeCode=='LY'" style="width: 60px"
            src=../../../static/images/LY.png alt="" />
          </div>
          <div class="cangkutit">
            {{ toFABck.country }}
            <span style="font-size: 14px">{{ toFABck.namec }}</span>
          </div>
        </div>
        <!-- ---上门提货--- -->
        <!-- <div class="Item_list" style="padding: 20px 0px 0px 0px">
          <div style="width: 100%; margin-bottom: 20px">
            <el-checkbox v-model="THFdata.checked" @change="changeTi">{{
              $t("i18n_pickup_at_original_port")
            }}</el-checkbox>
          </div>
          <div style="width: 100%; float: left" v-show="THFdata.checked">
            <div style="padding: 10px 0 0 25px; box-sizing: border-box">
              <el-form
                label-position="left"
                label-width="110px"
                :model="THFdata"
              >
                <el-form-item :label="$t('i18n_pickup_location')" size="">
                  <div
                    @click="changeCheic()"
                    style="
                      width: 344px;
                      height: 36px;
                      background: #ffffff;
                      border: 1px solid #e7e7e7;
                      border-radius: 5px;
                    "
                  >
                    <span style="float: left"
                      ><i
                        style="font-size: 16px; padding: 0 5px"
                        class="el-icon-location-outline"
                      ></i
                    ></span>
                    <span
                      style="
                        width: 290px;
                        height: 33px;
                        overflow: hidden;
                        display: inline-block;
                      "
                      >{{ countLIst_T.parvince }}{{ countLIst_T.city
                      }}{{ countLIst_T.area }}{{ countLIst_T.address }}</span
                    >
                    <span style="float: right"
                      ><i class="el-icon-arrow-right"></i
                    ></span>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('i18n_pickup_time')">
                  <div class="block">
                    <el-date-picker
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      style="width: 344px"
                      v-model="todoorTime"
                      type="date"
                      :placeholder="addPls('i18n_pickup_time', 'select')"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div> -->
        <!-- 尾程派送方式 -->
        <div class="Item_list send_end" v-if="finalDeliveryArray.length > 0">
          <div style="width: 100%; margin-bottom: 20px">尾程派送方式</div>
          <div class="send_end_content">
            <!-- <div class="send_content_item">
              <div class="send_item_left">入仓后自动选择费用最低的派送方式</div>
              <div class="send_item_right">
                <el-switch v-model="bestSendWay" @change="watchChose">
                </el-switch>
              </div>
            </div> -->
            <div
              class="send_content_secItem"
              v-for="(item, index) in finalDeliveryArray"
              :key="index"
            >
              <div class="send_item_left">
                <div>
                  <div class="send_item_two">
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="item.deliveryServiceRule"
                      placement="top"
                      style="border: none !important"
                    >
                      <el-link type="primary" :underline="false"
                        >计费规则</el-link
                      >
                    </el-tooltip>
                  </div>
                  <div style="color: #606266; font-weight: 500">
                    计费标准:{{ item.chargeUnit }}
                  </div>
                </div>
                <div class="send_left_one">
                  {{ item.deliveryService }}:
                  <div style="color: #f86670">
                    {{ item.price ? item.price : 0 }}
                  </div>
                  {{ item.currency }}
                </div>
              </div>
              <div class="send_item_right">
                <el-checkbox
                  disabled
                  v-model="item.checked"
                  @change="watchCheck(item)"
                ></el-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="demoLIst">
          <div style="width: 98%; float: left">
            <div
              class="LR_center"
              style="
                font-size: 18px;
                margin-top: 24px;
                width: 100%;
                font-weight: bold;
              "
            >
              <div
                style="
                  display: flex;
                  flex-flow: row nowrap;
                  align-items: center;
                "
              >
                <img
                  style="width: 20px; height: 22px"
                  src="../../assets/boxicon.png"
                  alt=""
                />
                <span style="margin-left: 10px">{{
                  $t("i18n_product_information")
                }}</span>
              </div>
              <div>
                <el-button
                  type="primary"
                  @click="
                    (excelVisible = true),
                      (errorLabel = []),
                      (isNewUpload = true)
                  "
                  size="mini"
                  :close-on-click-modal="false"
                  >{{ $t("i18n_Importing_boxes") }}({{
                    $t("i18n_By_summary")
                  }})<i class="el-icon-upload el-icon--right"></i
                ></el-button>
                <el-button
                  type="primary"
                  @click="
                    (excelVisible = true),
                      (errorLabel = []),
                      (isNewUpload = false)
                  "
                  size="mini"
                  :close-on-click-modal="false"
                  >{{ $t("i18n_Importing_boxes") }}({{
                    $t("i18n_By_detail")
                  }})<i class="el-icon-upload el-icon--right"></i
                ></el-button>
              </div>
            </div>
            <el-form
              label-position="left"
              class="demo-dynamic"
              size="mini"
              :model="ruleform"
              ref="ruleform"
            >
              <div
                class="cardWrap"
                v-for="(item, index) in ruleform.formLIst"
                :key="index"
              >
                <div class="box-card">
                  <div class="card_header">
                    <div class="boxindex">
                      {{ index + 1 }}
                    </div>
                    <div class="header_logo" style="cursor: pointer">
                      <div class="cloneType" @click="clone(item)">
                        {{ $t("i18n_Copy") }}
                      </div>
                      <div
                        class="deleteBtn"
                        v-if="ruleform.formLIst.length > 1"
                        @click="handleDelete(index, item)"
                      >
                        <i class="el-icon-error"></i>
                      </div>
                    </div>
                    <div class="">
                      <el-row :gutter="5" class="">
                        <!-- <el-col :span="6">
                          <el-form-item
                            label-width="78px"
                            class="rules"
                            label="商品类型"
                            :prop="'formLIst.' + index + '.goodstypeid'"
                            :rules="moreNotOjb.Nottypeid"
                          >
                            <el-select
                              style="width: 100%"
                              ref="changeFBAgoodtype"
                              v-model="item.goodstypeid"
                              placeholder="请选择"
                              @change="changeGStype(item.goodstypeid, index)"
                            >
                              <el-option
                                v-for="res in goodstypelist"
                                :key="res.id"
                                :label="res.cnName"
                                :value="res.id"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col> -->
                        <el-col :span="12">
                          <el-col :span="12">
                            <el-form-item
                              :label="$t('i18n_size_cm')"
                              label-width="86px"
                              class="rules"
                              :prop="'formLIst.' + index + '.length'"
                              :rules="moreNotOjb.Notlength"
                            >
                              <el-input
                                :placeholder="$t('i18n_length1')"
                                size="mini"
                                :min="0"
                                :max="9999"
                                v-model="item.length"
                                @change="
                                  getTimoney(index),
                                    getFBATrans(index),
                                    getCheckGlobalDelivery(index)
                                "
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item
                              class="rules"
                              label-width="5px"
                              :prop="'formLIst.' + index + '.width'"
                              :rules="moreNotOjb.Notwidth"
                            >
                              <el-input
                                :placeholder="$t('i18n_wide1')"
                                size="mini"
                                :min="0"
                                :max="9999"
                                v-model="item.width"
                                @change="
                                  getTimoney(index),
                                    getFBATrans(index),
                                    getCheckGlobalDelivery(index)
                                "
                              >
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item
                              label-width="5px"
                              class="rules"
                              :prop="'formLIst.' + index + '.height'"
                              :rules="moreNotOjb.Notheight"
                            >
                              <el-input
                                :placeholder="$t('i18n_height1')"
                                size="mini"
                                :min="0"
                                :max="9999"
                                v-model="item.height"
                                @change="
                                  getTimoney(index),
                                    getFBATrans(index),
                                    getCheckGlobalDelivery(index)
                                "
                              >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-col>
                        <el-col :span="5">
                          <div
                            class="LR_center"
                            style="
                              font-size: 12px;
                              font-weight: bold;
                              text-align: left;
                              margin-top: 8px;
                            "
                          >
                            <div style="">
                              <span style="color: #f86670">{{ item.cbm }}</span>
                              CBM
                            </div>
                            <!-- <div style="margin-right: 5px">
                              <span style="color: #e6a23c">{{
                                item.goodsDTOList ? item.goodsDTOList.length : 0
                              }}</span>
                              件商品
                            </div> -->
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <div class="card_count">
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item
                          class="rules"
                          label-width="78px"
                          :label="$t('i18n_FBA_number')"
                          :rules="moreNotOjb.Notboxnum"
                          :prop="'formLIst.' + index + '.fbxBoxNo'"
                        >
                          <el-input
                            :maxlength="maxlength"
                            type="text"
                            :placeholder="
                              billType
                                ? $t('i18n_fba_example')
                                : addPls('i18n_FBA_number', 'input')
                            "
                            v-model="item.fbxBoxNo"
                            size="mini"
                          >
                            <el-button
                              v-if="billType"
                              slot="suffix"
                              @click="(imageNum = 1), (imagesType = true)"
                              type="text"
                              >{{ $t("i18n_Example_diagram") }}</el-button
                            >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label-width="95px"
                          class="rules"
                          :label="$t('i18n_weight')"
                          :prop="'formLIst.' + index + '.weight'"
                          :rules="moreNotOjb.Notweight"
                        >
                          <el-input
                            size="mini"
                            @change="
                              getTimoney(),
                                getFBATrans(index),
                                getCheckGlobalDelivery()
                            "
                            :min="0"
                            :max="999"
                            v-model="item.weight"
                            :placeholder="addPls('i18n_weight', 'input')"
                          >
                            <i slot="suffix">(KG)</i>
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <!-- <el-col
                        :span="12"
                        v-if="billType && toFABck.countryCode == 'SA'"
                      >
                        <el-form-item
                          class="rules"
                          label-width="78px"
                          :label="$t('i18n_Shop_number')"
                          :rules="moreNotOjb.Notgoodsnum"
                        >
                          <el-input
                            v-model="item.shopName"
                            size="mini"
                          ></el-input>
                        </el-form-item>
                      </el-col> -->
                      <el-col
                        :span="12"
                        v-if="billType && toFABck.countryCode == 'SA'"
                      >
                        <el-form-item
                          class="rules"
                          label-width="95px"
                          :label="$t('i18n_Amazon_Reference_Number_PO')"
                          :prop="'formLIst.' + index + '.poTrackingNo'"
                          :rules="moreNotOjb.Notponum"
                        >
                          <el-input
                            size="mini"
                            maxlength="8"
                            v-model="item.poTrackingNo"
                            :placeholder="$t('i18n_reference_example')"
                          >
                            <el-button
                              slot="suffix"
                              @click="(imageNum = 2), (imagesType = true)"
                              type="text"
                              >{{ $t("i18n_Example_diagram") }}</el-button
                            >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                  <div
                    style="
                      width: 100%;
                      padding: 5px 20px;
                      box-sizing: border-box;
                    "
                  >
                    <!-- <div style="width:100%;padding-left:75px;">
                         <div class="goodLi" style="width:500px" v-for="(_item,_index) in item.goodsDTOList" :key="_index">
                            <div style="width:30px;float:left"><i style="font-size:18px" class="el-icon-shopping-cart-1"></i></div>
                            <div style="width:200px;float:left;overflow: hidden;color:#999999;font-weight: bold;font-size:12px"><span style="width:100px">{{_item.namec}} </span> <span style="margin-left:10px">({{_item.namee}})</span></div>
                            <div style="float:left;margin-left:20px" class="handNumber">
                              <el-input size="mini" v-model.number="_item.num" type="number" @change="handleChange" minlength="1" maxLength='9'>
                                 <i slot="prefix" class="el-input__icon el-icon-plus" @click="_item.num+=1"></i>
                                 <i slot="suffix" class="el-input__icon el-icon-minus" @click="_item.num-=1,_item.num<=1?_item.num=1:''"></i>
                              </el-input>
                            </div>
                            <div style="float:left;margin-left:20px" >
                              <el-button class="el-icon-delete" style="color:#f86670" type="text" size="mini" @click="delBoxgood(index,_index)">删除</el-button>
                            </div>
                         </div>
                      </div> -->
                    <!-- 折叠 -->
                    <el-collapse
                      @change="handleOPen(index)"
                      v-model="activeName"
                      style="width: 100%"
                    >
                      <el-collapse-item :name="index">
                        <template slot="title">
                          <i class="el-icon-coin"></i>
                          <span
                            style="
                              margin-left: 15px;
                              font-size: 13px;
                              font-weight: bold;
                            "
                            >{{
                              $t("i18n_product_number", {
                                num: item.goodsDTOList.length
                              })
                            }}</span
                          >
                          <span
                            class="el-icon-info"
                            style="
                              margin-left: 30px;
                              font-size: 12px;
                              color: #999;
                            "
                            >{{
                              $t("i18n_provide_accurate_quantity_value")
                            }}</span
                          >
                          <!-- 警示语 -->
                          <span
                            style="
                              margin-left: 30px;
                              font-size: 12px;
                              color: #f86670;
                            "
                          >
                            货值数据具有法律效应,请认真填写
                          </span>
                        </template>
                        <div
                          @click="clickme(_item)"
                          class="goodLi"
                          style="width: 100%"
                          v-for="(_item, _index) in item.goodsDTOList"
                          :key="_index"
                        >
                          <div style="width: 30px">
                            <i
                              style="font-size: 18px"
                              class="el-icon-shopping-cart-1"
                            ></i>
                          </div>
                          <div
                            style="
                              box-sizing: border-box;
                              width: 170px;
                              overflow: hidden;
                              color: #999999;
                              font-weight: bold;
                              font-size: 12px;
                              min-width: 170px;
                              white-space: nowrap;
                              word-break: break-all;
                              text-overflow: ellipsis;
                              overflow: hidden;
                              padding-right: 45px;
                            "
                          >
                            <span style="width: 100px">{{ _item.namec }} </span>
                            <span style="margin-left: 10px"
                              >({{ _item.namee }})</span
                            >
                          </div>
                          <div style="margin-left: 10px" class="handNumber">
                            <span class="numName" style="color: #999">{{
                              $t("i18n_quantity")
                            }}</span>
                            <el-input
                              size="mini"
                              v-model.number="_item.num"
                              type="number"
                              minlength="1"
                              maxLength="9"
                              oninput="if(isNaN(value)) { value = null } if(value<=0) {value=null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                            >
                              <i
                                slot="suffix"
                                class="el-input__icon el-icon-plus"
                                @click="_item.num += 1"
                              ></i>
                              <i
                                slot="prefix"
                                class="el-input__icon el-icon-minus"
                                @click="
                                  (_item.num -= 1),
                                    _item.num <= 1 ? (_item.num = 1) : ''
                                "
                              ></i>
                            </el-input>
                          </div>
                          <div
                            class="goodsValue"
                            style="margin-left: 20px; position: relative"
                          >
                            <span style="color: #999">
                              <!-- {{
                              $t("i18n_product_value")
                            }} -->
                              单个sku货值(USD)
                            </span>
                            <el-input
                              type="number"
                              :min="0"
                              style="width: 150px; border: none"
                              size="mini"
                              v-model="_item.declaredValue"
                              @change="
                                changeProValue(_item, _item.declaredValue)
                              "
                              :placeholder="$t('i18n_product_value1')"
                            >
                            </el-input>
                            <!--                            <div v-show="isShow(_item.declaredValue)" style="color: red; position: absolute; bottom: -20px; left: 90px ; font-size: 10px">大于零且保留最多三位小数</div>-->
                          </div>
                          <div style="margin-left: 20px; display: flex">
                            <el-button
                              class="el-icon-delete"
                              style="color: #f86670; margin-right: 10px"
                              type="text"
                              size="mini"
                              @click="delBoxgood(index, _index)"
                              >{{ $t("i18n_delete") }}</el-button
                            >
                            <!--                            <el-upload-->
                            <!--                              class="upload-img"-->
                            <!--                              ref="uploadImg"-->
                            <!--                              :before-upload="beforeImgUpload"-->
                            <!--                              :http-request="imgUpload"-->
                            <!--                              action=""-->
                            <!--                              :show-file-list="false">-->
                            <!--                              <el-button slot="trigger" type="text" @click="picUpload(index, _index)">{{$t('i18n_Image_upload')}}</el-button>-->
                            <!--                            </el-upload>-->
                            <el-button
                              slot="trigger"
                              type="text"
                              @click="showPictureManage(index, _index)"
                              >{{ $t("i18n_Image_manage") }}</el-button
                            >
                            <el-popover
                              v-if="_item.goodsUrl"
                              placement="right"
                              width="200"
                              trigger="click"
                            >
                              <el-image
                                :src="_item.goodsUrl ? _item.goodsUrl : ''"
                              ></el-image>
                              <el-button
                                slot="reference"
                                type="text"
                                style="margin-left: 10px"
                                >{{ $t("i18n_Preview") }}</el-button
                              >
                            </el-popover>
                          </div>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                    <!-- 折叠END -->
                    <div class="addStyle">
                      <el-button
                        plain
                        icon="el-icon-circle-plus-outline"
                        size="mini"
                        style="border-radius: 2px"
                        circle
                        @click="changegoods(index)"
                        >{{ $t("i18n_Select_product") }}</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </el-form>
            <!-- demo 测试 END -->
          </div>

          <div
            style="width: 100%; float: left; padding: 30px"
            class="TB_center"
          >
            <el-button
              style="border-radius: 20px"
              type="primary"
              size="medium"
              @click="addItem('ruleform')"
              >+{{ $t("i18n_New_box") }}</el-button
            >
          </div>
        </div>
      </div>
      <div class="wrap_R" :class="auto_fixed ? 'auto_fixed' : ''">
        <p
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #343434;
          "
        >
          {{ $t("i18n_cost_calculation") }}
        </p>
        <div class="Item_Right animate__animated animate__bounceInRight">
          <p class="tit">{{ $t("i18n_shipping_cost") }}</p>
          <p
            class="coutText"
            v-for="(item, index) in FBATransmoney.goodsTypeFeeDTOS"
            :key="index"
          >
            <span class="littit">{{ item.goodsTypeName }}</span>
            <span class="fontString">{{ item.currency }}{{ item.amount }}</span>
            <span style="margin-left: 10px">({{ item.calDesc }})</span>
          </p>
          <p class="coutText">
            <span class="littit">{{ $t("i18n_subtotal") }}</span>
            <span class="fontString"
              >{{ FBATransmoney.currency }}{{ FBATransmoney.amount }}</span
            >
          </p>
        </div>
        <!-- 暂时隐藏尾程派送费 -->
        <!-- <div
          class="Item_Right animate__animated animate__bounceInRight"
          v-if="this.isGlobalDelivery && !this.isGlobalSea"
        >
          <p class="tit">{{ $t("i18n_global_delivery_cost") }}</p>
          <p class="coutText">
            <span class="littit">{{ $t("i18n_subtotal") }}</span>
            <span class="fontString"
              >{{ GlobalDelivery.currency }}{{ GlobalDelivery.amount }}</span
            >
            <span style="margin-left: 10px"
              >{{ "(" }}{{ GlobalDelivery.calDesc }}{{ ")" }}</span
            >
          </p>
        </div> -->

        <div
          class="Item_Right animate__animated animate__bounceInRight"
          v-show="THFdata.checked"
        >
          <p class="tit">{{ $t("i18n_pickup_fee") }}</p>
          <p class="coutText">
            <span class="littit">{{ $t("i18n_pickup_at_original_port") }}</span>
            <span class="fontString"
              >{{ THFdata.currency }}{{ THFdata.amount }}</span
            >
            <span
              class="littit"
              style="float: left; width: 100%"
              v-if="THFdata.maxKilometer > 0"
              >({{ THFdata.minKilometer }}--{{ THFdata.maxKilometer }})
              {{ $t("i18n_Kilometers") }}</span
            >
          </p>
        </div>
        <div class="Item_Right">
          <p class="">
            <span class="littit">{{ $t("i18n_Total_payment") }}</span>
            <span
              v-for="(item, index) in this.newArray"
              :key="index"
              v-show="item.amount > 0"
            >
              <span
                ><span
                  style="padding-left: 10px"
                  class="fontString"
                  v-show="item.currency != ''"
                  >{{ item.currency }}</span
                >
                <span
                  class="fontString"
                  v-show="item.amount > 0"
                  style="margin-left: 5px; margin-right: 5px"
                  >{{ item.amount }}</span
                ></span
              >
              <span v-show="index == newArray.length - 1 ? false : true"
                >+</span
              >
            </span>
          </p>
          <p class="coutText">
            <span class="littit">{{ $t("i18n_Covert_to_CNY") }}</span>
            <span class="fontString">CNY {{ calculatePrice }}</span>
          </p>
        </div>
        <div class="goodsValueCount">
          <div class="goodsValue_name">货值统计</div>
          <div class="goodsValue_fat">
            <div class="goodsValue_box">箱数:{{ getBoxNum }} 箱</div>
            <div class="goodsValue_value">货值:{{ getGoodsValue }} USD</div>
          </div>
        </div>
        <div style="width: 100%; margin-top: 130px; float: left">
          <div style="width: 100%">
            <el-button style="width: 100%" @click="pathToback()">{{
              $t("i18n_Previousstep")
            }}</el-button>
          </div>
          <div style="width: 100%; margin-top: 10px">
            <el-button
              style="width: 100%; background: #5ab53c; color: #ffffff"
              @click="pathToNext('ruleform')"
              >{{ $t("i18n_Next_step") }}</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 地址弹窗 -->
    <div class="dialogCover" @click.self="closeMyDialog()" v-if="showMydialog">
      <div class="myDialog">
        <!-- header  -->
        <div style="display: flex; justify-content: space-between">
          <span style="font-weight: 600">{{ $t("i18n_pickup_address") }}</span>
          <i
            class="el-icon-close"
            @click="closeMyDialog()"
            style="cursor: pointer"
          ></i>
        </div>
        <!-- body   -->
        <div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin: 20px 0;
            "
          >
            <div>
              <el-input
                clearable
                @clear="getPeopletable()"
                v-model="nameOrPhone"
                @keyup.native="searchNameOrPhone"
                :placeholder="$t('i18n_name_or_phone_number')"
                size="medium"
                style="width: 450px"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                <el-button slot="append" type="primary">{{
                  $t("i18n_Search")
                }}</el-button>
              </el-input>
            </div>

            <el-button
              size="medium"
              plain
              type="primary"
              @click="showAdd(true)"
              >{{ $t("i18n_Create_new_address") }}</el-button
            >
          </div>
          <!-- 新增或编辑 -->
          <div
            v-if="edit"
            style="
              background-color: #fff;
              border-radius: 20px;
              padding: 20px;
              box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
            "
          >
            <div style="width: 85%; margin: 0 auto; max-width: 600px">
              <el-row
                :gutter="20"
                style="margin-bottom: 8px; margin-left: 1px; display: flex"
              >
                <div style="display: flex">
                  <div
                    class="grid-content"
                    style="margin-right: 5px; min-width: 100px"
                  >
                    <span style="line-height: 40px">{{
                      $t("i18n_contact_person")
                    }}</span>
                  </div>

                  <div class="grid-content">
                    <el-input
                      v-model="submitForm.name"
                      :placeholder="addPls('i18n_contact_person', 'input')"
                      style="width: 240px"
                    ></el-input>
                  </div>
                </div>
                <div style="display: flex">
                  <div
                    class="grid-content"
                    style="
                      margin-left: 10px;
                      margin-right: 10px;
                      min-width: 80px;
                    "
                  >
                    <span style="line-height: 40px">{{
                      $t("i18n_contact_info")
                    }}</span>
                  </div>

                  <div class="grid-content">
                    <el-input
                      v-model="submitForm.tel"
                      :placeholder="addPls('i18n_contact_info', 'input')"
                      style="width: 210px"
                    ></el-input>
                  </div>
                </div>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <span style="line-height: 40px">{{
                      $t("i18n_contact_address")
                    }}</span>
                  </div></el-col
                >
                <el-col :span="18">
                  <div class="grid-content">
                    <el-cascader
                      :options="jackCitylist"
                      :placeholder="addPls('i18n_contact_address', 'select')"
                      v-model="value"
                      clearable
                      @change="handleChange"
                      :props="props"
                      style="width: 270px"
                    >
                    </el-cascader>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <div
                      style="line-height: 40px; width: 10px; height: 10px"
                    ></div></div
                ></el-col>
                <el-col :span="18"
                  ><div class="grid-content">
                    <el-input
                      v-model="submitForm.address"
                      type="textarea"
                      rows="2"
                      :placeholder="
                        $t('i18n_please_enter_the_detailed_location')
                      "
                    ></el-input></div
                ></el-col>
              </el-row>
              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <span style="line-height: 40px">{{
                      $t("i18n_label")
                    }}</span>
                  </div></el-col
                >
                <el-col :span="18"
                  ><div class="grid-content">
                    <el-input
                      v-model="submitForm.tag"
                      :placeholder="addPls('i18n_label', 'input')"
                    ></el-input></div
                ></el-col>
              </el-row>

              <div style="width: 330px; margin: 0 auto; text-align: center">
                <div style="display: flex">
                  <el-checkbox
                    text-color="#5F4AFF"
                    v-model="submitForm.isdefault"
                    style="margin-right: 10px"
                  ></el-checkbox>
                  <span style="display: block; margin-bottom: 8px">
                    {{ $t("i18n_set_to_default_address") }}
                  </span>
                </div>
                <el-button
                  @click="addAddr"
                  style="
                    background: #5f4aff;
                    border: 1px solid #5f4aff;
                    border-radius: 5px;
                    color: #fff;
                  "
                  >{{
                    $t(this.submitForm.id ? "i18n_edit" : "i18n_add")
                  }}</el-button
                >
                <el-button type="info" @click="showAdd(false)">{{
                  $t("i18n_Close")
                }}</el-button>
              </div>
            </div>
          </div>

          <el-table
            v-if="!edit"
            @row-click="rowClick"
            size="mini"
            height="300"
            tooltip-effect="dark"
            :data="tableData"
            max-height="200"
            highlight-current-row
            border
            ref="Table"
            style="width: 100%; overflow: hidden"
          >
            <el-table-column
              :label="$t('i18n_Name')"
              width="100"
              align="center"
              prop="name"
            >
            </el-table-column>
            <el-table-column
              :label="$t('i18n_Phone')"
              width="120"
              align="center"
              prop="tel"
            >
            </el-table-column>
            <el-table-column
              :label="$t('i18n_contact_address')"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.parvince }}
                {{ scope.row.city }}
                {{ scope.row.area }}
                {{ scope.row.address }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('i18n_Operation')"
              align="center"
              width="160"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="setDefault(scope.row)"
                >
                  <span
                    :style="
                      scope.row.isdefault ? 'color:#604AFF' : 'color:#9A9A9A'
                    "
                    >{{
                      $t(
                        scope.row.isdefault
                          ? "i18n_Default"
                          : "i18n_set_to_default"
                      )
                    }}</span
                  >
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleEdit(scope.$index, scope.row)"
                  >{{ $t("i18n_edit") }}</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="DeleteTitem(scope.$index, scope.row)"
                  >{{ $t("i18n_delete") }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-alert
            v-if="!edit"
            style="margin-top: 20px"
            :title="$t('i18n_Click_line_select_address')"
            type="info"
            center
            show-icon
          >
          </el-alert>
        </div>
      </div>
    </div>
    <!-- 地址弹窗 END -->
    <!-- 商品列表 -->
    <el-dialog
      :title="$t('i18n_Product_List')"
      width="950px"
      :visible.sync="goodsTypeShow"
    >
      <div class="typeHeader LR_center">
        <div>
          <el-input
            style="width: 314px"
            :placeholder="addPls('i18n_Product_name_in_Chinese', 'input')"
            v-model="Sgodname"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              type="primary"
              @click="getgoodsData(Sgodname)"
              >{{ $t("i18n_Search") }}</el-button
            >
          </el-input>
        </div>
        <div>
          <el-select
            clearable
            style="width: 100%"
            ref="changeFBAgoodtype"
            :placeholder="addPls('i18n_Product_Type', 'select')"
            v-model="ThatgoodsID"
            @change="getgoodsData(Sgodname)"
          >
            <el-option
              v-for="res in goodstypelist"
              :key="res.id"
              :label="res.cnName"
              :value="res.id"
            ></el-option>
          </el-select>
        </div>
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            plain
            @click="addgoods()"
            >{{ $t("i18n_New_Products") }}</el-button
          >
          <!-- <el-button type="primary" icon="el-icon-download" plain
            >导入商品</el-button
          > -->
        </div>
      </div>

      <div class="countTable" style="margin-top: 30px">
        <el-table
          ref="multipleTable"
          border
          :data="goodsLabel"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" fixed="left">
          </el-table-column>
          <el-table-column
            :label="$t('i18n_Product_name_in_Chinese')"
            align="center"
            width="120"
          >
            <template slot-scope="scope">{{ scope.row.namec }}</template>
          </el-table-column>
          <el-table-column
            prop="namee"
            :label="$t('i18n_product_name_in_English')"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="materialc"
            align="center"
            :label="$t('i18n_Material_in_Chinese')"
          >
          </el-table-column>
          <el-table-column
            prop="materiale"
            align="center"
            :label="$t('i18n_Material_in_English')"
          >
          </el-table-column>
          <el-table-column
            prop="purposec"
            align="center"
            :label="$t('i18n_Uses')"
          >
          </el-table-column>
          <el-table-column
            prop="hsCode"
            align="center"
            :label="$t('i18n_HTS_code')"
          >
          </el-table-column>
          <el-table-column
            prop="goodstype"
            align="center"
            :label="$t('i18n_cargo_classification')"
          >
          </el-table-column>
          <el-table-column prop="sku" align="center" label="SKU">
          </el-table-column>
          <el-table-column
            prop="goodstype"
            align="center"
            :label="$t('i18n_electric_or_not')"
          >
            <template slot-scope="scope">
              {{ $t(scope.row.isHasBattery ? "i18n_yes" : "i18n_no") }}
            </template>
          </el-table-column>
          <el-table-column
            prop="goodstype"
            align="center"
            :label="$t('i18n_liquid_power_or_not')"
          >
            <template slot-scope="scope">
              {{ $t(scope.row.isPowderLiquid ? "i18n_yes" : "i18n_no") }}
            </template>
          </el-table-column>
          <el-table-column
            prop="goodstype"
            align="center"
            :label="$t('i18n_magnetic_or_not')"
          >
            <template slot-scope="scope">
              {{ $t(scope.row.isHasMagnetism ? "i18n_yes" : "i18n_no") }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('i18n_Operation')"
            fixed="right"
            align="center"
            width="100"
          >
            <template slot-scope="scope" v-if="scope.row.customerid">
              <el-button
                type="text"
                size="mini"
                @click="goodsEdit(scope.$index, scope.row)"
                >{{ $t("i18n_edit") }}</el-button
              >
              <el-button
                size="mini"
                type="text"
                style="color: red"
                @click="delGoodItem(scope.$index, scope.row)"
                >{{ $t("i18n_delete") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="qdBtn TB_center" style="width: 100%; margin-top: 50px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :total="goodslisttotal"
          ></el-pagination>
        </div>
        <div class="qdBtn TB_center" style="width: 100%; margin-top: 50px">
          <el-button type="primary" @click="setGoodspush()">{{
            $t("i18n_Confirmation_selection")
          }}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 新增编辑商品弹窗 -->
    <el-dialog
      :title="$t('i18n_Create_new_product')"
      :visible.sync="goodstextShow"
      width="850px"
    >
      <div style="width: 100%">
        <el-form
          size="small"
          ref="addgoodform"
          :model="addgoodform"
          label-width="110px"
          class="LR_center"
          :label-position="lang === 'zh' ? 'right' : 'top'"
        >
          <div style="width: 45%">
            <el-form-item
              style="width: 100%"
              :label="$t('i18n_Product_name_in_Chinese')"
              :rules="{
                required: true,
                message: '中文品名不能为空',
                trigger: 'blur'
              }"
            >
              <el-input
                :placeholder="addPls('i18n_Product_name_in_Chinese', 'input')"
                v-model="addgoodform.namec"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              :label="$t('i18n_Product_Type')"
              :rules="{
                required: true,
                message: '商品类型不能为空',
                trigger: 'blur'
              }"
            >
              <el-select
                clearable
                style="width: 100%"
                ref="changeFBAgoodtype"
                :placeholder="addPls('i18n_Product_Type', 'select')"
                v-model="addgoodform.goodstypeid"
              >
                <el-option
                  v-for="res in goodstypelist"
                  :key="res.id"
                  :label="res.cnName"
                  :value="res.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <!-- <el-select
              clearable
              style="width: 100%"
              ref="changeFBAgoodtype"
              placeholder="请选择商品类型"
              v-model="ThatgoodsID"
              @change="getgoodsData(Sgodname)">
                   <el-option v-for="res in goodstypelist" :key="res.id" :label="res.cnName" :value="res.id"></el-option>
          </el-select> -->

            <el-form-item style="width: 100%" :label="$t('i18n_brands')">
              <el-input
                :placeholder="addPls('i18n_brands', 'input')"
                v-model="addgoodform.brand"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" :label="$t('i18n_HTS_code')">
              <el-input
                :placeholder="addPls('i18n_HTS_code', 'input')"
                v-model="addgoodform.hsCode"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              :label="$t('i18n_Material_in_Chinese')"
            >
              <el-input
                :placeholder="addPls('i18n_Material_in_Chinese', 'input')"
                v-model="addgoodform.materialc"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              :label="$t('i18n_Product_uses_in_Chinese')"
            >
              <el-input
                style="width: 100%"
                :placeholder="addPls('i18n_Product_uses_in_Chinese', 'input')"
                v-model="addgoodform.purposec"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              :label="$t('i18n_electric_or_not')"
              :rules="{
                required: true,
                message: '请选择是否带电',
                trigger: 'blur'
              }"
            >
              <el-select
                style="width: 100%"
                v-model="addgoodform.isHasBattery"
                :placeholder="$t('i18n_please_choose')"
              >
                <el-option :label="$t('i18n_yes')" :value="true"> </el-option>
                <el-option :label="$t('i18n_no')" :value="false"> </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="width: 45%">
            <el-form-item
              style="width: 100%"
              :label="$t('i18n_product_name_in_English')"
              :rules="{
                required: true,
                message: '英文品名不能为空',
                trigger: 'blur'
              }"
            >
              <el-input
                style="width: 100%"
                :placeholder="addPls('i18n_product_name_in_English', 'input')"
                v-model="addgoodform.namee"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="SKU">
              <el-input
                :placeholder="addPls('SKU', 'input')"
                v-model="addgoodform.sku"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              :label="$t('i18n_product_value')"
              :rules="{
                required: true,
                message: '货值不能为空',
                trigger: 'blur'
              }"
            >
              <el-input
                :placeholder="addPls('i18n_product_value', 'input')"
                type="number"
                v-model.number="addgoodform.declaredValue"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              :label="$t('i18n_material_in_English')"
            >
              <el-input
                :placeholder="addPls('i18n_material_in_English', 'input')"
                v-model="addgoodform.materiale"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              :label="$t('i18n_Product_uses_in_English')"
            >
              <el-input
                :placeholder="addPls('i18n_Product_uses_in_English', 'input')"
                v-model="addgoodform.purposee"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              :label="$t('i18n_liquid_power_or_not')"
              :rules="{
                required: true,
                message: '请选择是否液体/粉末',
                trigger: 'blur'
              }"
            >
              <el-select
                style="width: 100%"
                v-model="addgoodform.isPowderLiquid"
                :placeholder="$t('i18n_please_choose')"
              >
                <el-option :label="$t('i18n_yes')" :value="true"> </el-option>
                <el-option :label="$t('i18n_no')" :value="false"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              :label="$t('i18n_magnetic_or_not')"
              :rules="{
                required: true,
                message: '请选择是否带磁',
                trigger: 'blur'
              }"
            >
              <el-select
                style="width: 100%"
                v-model="addgoodform.isHasMagnetism"
                :placeholder="$t('i18n_please_choose')"
              >
                <el-option :label="$t('i18n_yes')" :value="true"> </el-option>
                <el-option :label="$t('i18n_no')" :value="false"> </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div
          style="width: 100%; padding: 30px; box-sizing: border-box"
          class="TB_center"
        >
          <el-button type="primary" @click="addgoodtext('addgoodform')">{{
            $t(
              GoodsCategory ? "i18n_confirm_addition" : "i18n_confirm_revision"
            )
          }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增编辑商品弹窗END -->

    <!-- Excel上传 -->
    <el-dialog
      :title="$t('i18n_Download_Template')"
      :visible.sync="excelVisible"
      width="40%"
      center
    >
      <el-upload
        style="text-align: center"
        :show-file-list="false"
        :on-error="handleError"
        :on-success="handleSuccess"
        :before-upload="handleBeforeUpload"
        :http-request="uploadSectionFile"
        class="upload-demo"
        drag
        action=""
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          {{ $t("i18n_Drag_file_here_or")
          }}<em>{{ $t("i18n_click_Upload") }}</em>
        </div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 20px"
          size="mini"
          @click="excelVisible = false"
          >{{ $t("i18n_cancel") }}</el-button
        >
        <el-link target="_blank">
          <el-button size="mini" type="success" @click="Getdown()">{{
            $t("i18n_Download_Template")
          }}</el-button>
        </el-link>
      </span>
      <template>
        <el-table
          v-show="errorLabel.length > 0"
          :data="errorLabel"
          size="mini"
          border
          style="width: 100%"
        >
          <el-table-column
            align="center"
            width="80"
            type="index"
            :label="$t('i18n_Serial_number')"
          >
          </el-table-column>
          <el-table-column
            align="center"
            width="80"
            prop="order"
            :label="$t('i18n_Number_of_rows')"
          >
          </el-table-column>
          <el-table-column :label="$t('i18n_Error_Description')">
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.desc }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>

    <!-- 示例图 -->
    <el-dialog
      :title="$t('i18n_Example_diagram')"
      :visible.sync="imagesType"
      width="600px"
      center
    >
      <img
        v-show="imageNum == 1"
        src="../../../static/images/boxdemo.png"
        alt=""
      />
      <img
        v-show="imageNum == 2"
        src="../../../static/images/ponum.png"
        alt=""
      />
    </el-dialog>
    <!--  图片管理  -->
    <el-dialog
      title="图片管理"
      :visible.sync="pictureManage"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
      @close="handleClose"
      @closed="uploadDialogClose"
    >
      <el-upload
        ref="pictureManage"
        action=""
        :file-list="fileList"
        list-type="picture-card"
        accept=".png,.jpg,.jpeg"
        :on-preview="handlePictureCardPreview"
        :http-request="uploadPicture"
        :on-change="handleUploadError"
        :on-remove="handleUploadRemove"
        :before-upload="beforeImgUpload"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-button slot="footer" type="primary" @click="clickSavePictureManage"
        >保存</el-button
      >
    </el-dialog>
    <el-dialog :visible.sync="previewVisible">
      <img :src="previewUrl" width="100%" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import { addPls, cannotBeEmpty } from '@/utils/placeholderI18n.js'
import { isArray, isObject } from "../../assets/js/utils";

function baseDataGoodsItem() {
  return {
    "id": 18986587700,
    "customerid": null,
    "goodstypeid": 18986549800,
    "namec": "地毯",
    "namee": "Carpets",
    "hsCode": null,
    "brand": null,
    "sku": null,
    "materialc": "腈纶",
    "materiale": "Acrylic ",
    "purposec": null,
    "purposee": null,
    "declaredValue": null,
    "countryId": 0,
    "country": "阿联酋",
    "goodstype": "普货",
    "customerCode": null,
    "customerName": null,
    "inputer": null,
    "inputtime": null,
    "isHasBattery": false,
    "isPowderLiquid": false,
    "isHasMagnetism": false,
    "num": 3,
    // goodsUrl 弃用，改用goodsUrlList
    "goodsUrl": "http://d2d-test.oss-cn-shenzhen.aliyuncs.com/goods_images/1689566824437_-1032810977.jpg?Expires=1689570424&OSSAccessKeyId=LTAI4G5AbiteWxgPHxgc64jJ&Signature=07I1I7yeNB3ap7gUS0IVuC3XSSc%3D",
    // 商品的图片列表
    "goodsUrlList": [],
  }
}
export default {
  data() {
    return {
      // 尾程派送方式费用数组
      finalDeliveryArray: [],
      // 控制最低派送方式
      bestSendWay: true,
      maxlength: 19,
      billType: null,
      imageNum: 1,
      imagesType: false,
      PathCBM: 0,
      goodTypeIds: '',
      // 导入箱子返回错误文本集
      errorLabel: [],
      upUrl: '',
      // 导入箱子弹窗
      excelVisible: false,
      // 导入箱子类型 true-按汇总 false-按明细
      isNewUpload: false,
      transportTypeCode: null,
      goodstextShow: false,
      goodsTypeShow: false,
      GoodsCategory: true, //true是新增 false是修改
      Sgodname: "",
      // jack
      getLIstType: "",
      props: {
        value: "namec",
        label: "namec",
      },
      value: [],
      countLIst_T: {
        address: "",
        area: "",
        city: "",
        customerid: "",
        id: "",
        isdefault: null,
        name: "",
        parvince: "",
        tag: "",
        tel: "",
      },
      showMydialog: false,
      jackCitylist: [],
      submitForm: {
        address: "",
        area: "",
        city: "",
        customerid: 0,
        id: 0,
        isdefault: false,
        name: "",
        parvince: "",
        tag: "",
        tel: "",
      },
      edit: false,
      nameOrPhone: "",
      tableData: [],
      tempTableData: [],
      goodslisttotal: 0,
      // jack end
      goodstypelist: [],
      moreNotOjb: {
        Nottypeid: [
          { required: true, message: this.cannotBeEmpty("i18n_cargo_classification") },
          // {
          //   validator: (rule, value, callback) => {   校验正整数
          //     if (value.length > 15 || value.length < 1) {
          //       callback(new Error("长度只能为1-15个字符"));
          //     } else {
          //       var reg = /^[1-9]\d*$/;
          //       if (!reg.test(value)) {
          //         callback(new Error("件数不能小于等于0"));
          //       } else {
          //         callback();
          //       }
          //     }
          //   },
          //   trigger: "change",
          // },
        ],
        Notponum: [
          { required: true, message: this.cannotBeEmpty("i18n_Amazon_Reference_Number_PO") },
          {
            validator: (rule, value, callback) => {
              if (value.length > 8 || value.length < 8) {
                callback(new Error(this.$t("i18n_Length_of_characters", { num: 8 })));
              } else {
                var reg = /^[a-zA-Z0-9]+$/;
                if (!reg.test(value)) {
                  callback(new Error(this.$t("i18n_Numbers_letters_only")));
                } else {
                  callback();
                }
              }
            },
            trigger: "change",
          },
        ],
        Notgoodsnum: [{ required: true, message: this.cannotBeEmpty("i18n_Shop_number") }],
        Notboxnum: [
          { required: true, message: this.cannotBeEmpty("i18n_Box_number") },
          {
            validator: (rule, value, callback) => {
              var index = value.toLowerCase().indexOf('fba');
              if (this.billType) {
                if (index == 0) {
                  // if (value.length < 19||value.length >19) {
                  //   callback(new Error(this.$t("i18n_Length_of_characters", {num:19})));
                  // }else{
                  //   callback();
                  // }
                  callback()
                } else {
                  callback(new Error(this.$t("i18n_Must_start_with_FBA")));
                }
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        goodsNotname: [{ required: true, message: this.cannotBeEmpty("i18n_product_name") }],
        Notweight: [
          { required: true, message: this.cannotBeEmpty("i18n_weight") },
          {
            validator: (rule, value, callback) => {
              if (value.length > 15 || value.length < 1) {
                callback(new Error(this.$t("i18n_Length_of_characters", { num: '1-15' })));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,3})?$)/;
                if (value <= 0) {
                  callback(new Error(this.$t("i18n_more_than0_two_decimal")));
                }
                if (!reg.test(value)) {
                  callback(new Error(this.$t("i18n_more_than0_two_decimal")));
                } else {
                  callback();
                }
              }
            },
            trigger: "change",
          },
        ],
        Notlength: [
          { required: true, message: this.cannotBeEmpty("i18n_length1") },
          {
            validator: (rule, value, callback) => {
              if (value.length > 15 || value.length < 1) {
                callback(new Error(this.$t("i18n_Length_of_characters", { num: '1-15' })));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,3})?$)/;
                if (value <= 0) {
                  callback(new Error(this.$t("i18n_more_than0_two_decimal")));
                }
                if (!reg.test(value)) {
                  callback(new Error(this.$t("i18n_more_than0_two_decimal")));
                } else {
                  callback();
                }
              }
            },
            trigger: "change",
          },
        ],
        Notwidth: [
          { required: true, message: this.cannotBeEmpty("i18n_wide1") },
          {
            validator: (rule, value, callback) => {
              if (value.length > 15 || value.length < 1) {
                callback(new Error(this.$t("i18n_Length_of_characters", { num: '1-15' })));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,3})?$)/;
                if (!reg.test(value)) {
                  callback(new Error(this.$t("i18n_more_than0_two_decimal")));
                } else {
                  callback();
                }
              }
            },
            trigger: "change",
          },
        ],
        Notheight: [
          { required: true, message: this.cannotBeEmpty("i18n_height1") },
          {
            validator: (rule, value, callback) => {
              if (value.length > 15 || value.length < 1) {
                callback(new Error(this.$t("i18n_Length_of_characters", { num: '1-15' })));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,3})?$)/;
                if (!reg.test(value)) {
                  callback(new Error(this.$t("i18n_more_than0_two_decimal")));
                } else {
                  callback();
                }
              }
            },
            trigger: "change",
          },
        ],
      },

      SonshowType: true,
      defaultParams: {
        label: "namec",
        value: "namec",
        children: "children",
      },
      shouaddressid: [],
      WaicountLIst: [],
      showType: false,
      addType: false,
      Timeshow: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      auto_fixed: false,
      cbm: null,
      Citydata: null,
      fromFABck: localStorage.getItem("fromFABck")
        ? JSON.parse(localStorage.getItem("fromFABck"))
        : {},
      toFABck: localStorage.getItem("toFABck")
        ? JSON.parse(localStorage.getItem("toFABck"))
        : {},
      PStablelist: [],
      searchPSname: "",
      FBATransmoney: {
        //运输费
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },

      newTihuoarr: "", //需展示的提货地址
      todoorTime: null,
      isGlobalDelivery: false, //是否属于全境派送产品
      isGlobalSea: false, //是否属于全境派送--海运产品
      GlobalDelivery: {
        //全境派送费
        amount: "",
        cnyamount: "",
        currency: "",
        piece: "",
        price: "",
        calDesc: "",
      },
      THFdata: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
        minKilometer: '',
        maxKilometer: '',
      },
      pageNum: 1,
      ruleform: {
        // 商品信息的箱子列表
        formLIst: [
          {
            goodstypeid: "", //货物类型
            typeName: "", //货物类型名字
            weight: "", //重量
            length: "", //长
            width: "", //宽
            height: "", //高
            shopName: "", //商户号
            poTrackingNo: "", //po追踪号
            fbxBoxNo: "", //箱号
            cbm: 0,
            // 箱子内的商品列表
            goodsDTOList: [
            ],
            sortNum: 1,
            goodsDTOnum: ''
          },
        ],
      },
      contactype2: "",
      dialogFormVisible: false,
      totalMolist: [],
      clickPsitem: {}, //当前点击收货地址item
      addgoodform: {
        id: "",
        brand: "",
        customerid: "",
        declaredValue: "",
        goodstypeid: "",
        hsCode: "",
        materialc: "",
        materiale: "",
        namec: "",
        namee: "",
        purposec: "",
        purposee: "",
        sku: "",
        isHasBattery: '',
        isPowderLiquid: '',
        isHasMagnetism: '',
        // 产品id
        productId: ''
      },
      setLIstdata: [],
      thatGoodslist: [],
      goodsLabel: [],
      ThatgoodsID: "",
      BoxWrapindex: null,
      activeLIst: [],
      thatindexgslist: [],
      // 记录 上传图片 操作的箱子index
      boxIndex: 0,
      // 记录 上传图片 操作的箱子内的商品index
      goodIndex: 0,
      // 图片管理弹窗
      pictureManage: false,
      // 图片管理弹窗 上传成功后保存的完整图片链接列表 (上传接口返回的相对（短）链接 通过/erp/service?src=lcljobs&action=previewListBoxPic 或 /busFbx/previewGoodsPic 接口交换的完整链接)
      pictureFullList: [],
      // 图片管理弹窗默认展示图片列表，（格式为：pictureFullList的完整链接["","",...]，组合成的[{name,url}]数组对象）
      fileList: [],
      // 图片管理弹窗 缓存默认展示和已上传图片列表的fileName，供移除时匹配
      imgNameList: [],
      // 查看大图弹窗
      previewVisible: false,
      // 查看大图 图片链接
      previewUrl: '',
    };
  },
  watch: {
    "ruleform.formLIst": {
      handler(newVal, oldval) {
        // 设置箱数
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.$store.commit("setGoodsCount", {
            boxNum: newVal.length
          })
        } else {
          this.$store.commit("setGoodsCount", {
            boxNum: 0
          })
        }
        // 设置货值
        if (Array.isArray(newVal) && newVal.length > 0) {
          let proValue = 0
          newVal.map(item => {
            if (Array.isArray(item.goodsDTOList) && item.goodsDTOList.length > 0) {
              item.goodsDTOList.map(sinItem => {
                if (Number(sinItem.declaredValue) > 0) {
                  proValue += Number(sinItem.declaredValue) * Number(sinItem.num)
                } else {
                  proValue += 0
                }
              })
            }
          })
          this.$store.commit("setGoodsValue", {
            proValue: proValue
          })
        } else {
          this.$store.commit("setGoodsValue", {
            proValue: 0
          })
        }
      },
      deep: true
    }
  },
  computed: {
    // 箱数统计
    getBoxNum() {
      return this.$store.state.goodsValueCount.boxNum
    },
    // 货值统计
    getGoodsValue() {
      return this.$store.state.goodsValueCount.proValue
    },
    activeName() {
      let activeName = [];
      this.ruleform.formLIst.forEach((item, index) => {
        activeName.push(index);
      });
      this.activeLIst = activeName;
      return activeName;
    },
    calculatePrice() {
      //计算总费用
      let Totalmoney = 0; //总费用
      let FBATransmoney = 0; //运输费
      let THFmoney = 0; //提货费
      let GlobalDeliveryCny = 0; //全境派送费
      FBATransmoney = this.FBATransmoney.cnyamount
        ? +this.FBATransmoney.cnyamount
        : 0;
      if (this.THFdata.checked) {
        //如果有提货费
        THFmoney = this.THFdata.cnyamount ? +this.THFdata.cnyamount : 0;
      }
      // if (this.isGlobalDelivery && !this.isGlobalSea) {
      //   GlobalDeliveryCny = this.GlobalDelivery.cnyamount ? +this.GlobalDelivery.cnyamount : 0;
      // }
      Totalmoney = FBATransmoney + THFmoney + GlobalDeliveryCny;
      return Totalmoney.toFixed(2);
    },
    newArray() {
      //监听 币种
      let totalFeiyong = []; //当前勾选
      totalFeiyong.push(JSON.parse(JSON.stringify(this.FBATransmoney))); //海运费币种
      if (this.THFdata.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.THFdata))); //提货费费币种
      }
      // if (this.isGlobalDelivery && !this.isGlobalSea) {
      //   totalFeiyong.push(JSON.parse(JSON.stringify(this.GlobalDelivery))); //全境派送
      // }
      console.log("totalFeiyong", totalFeiyong)
      let newArray = totalFeiyong.reduce((total, cur, index) => {
        let hasValue = total.findIndex((current) => {
          return current.currency === cur.currency;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 &&
          (total[hasValue].amount = this.accAdd(
            total[hasValue].amount,
            cur.amount
          ));
        return total;
      }, []);
      return newArray;
    },
    lang() {
      return this.$store.state.lang
    }
  },
  methods: {
    /**
     * 修改货值
     * @param pro 商品
     * @param proVal 商品货值
     * */
    changeProValue(pro, proVal) {
      if (typeof Number(proVal) === 'number' && Number(proVal) > 0) {
        pro.declaredValue = Number(proVal)
      } else {
        pro.declaredValue = 0
      }
    },
    /**
     * 监听入仓费用仅能单选
     * @param item 入仓费用项
     * */
    watchCheck(item) {
      let itemId = item.id
      this.finalDeliveryArray.map(sinItem => {
        if (sinItem.id == itemId) {
          sinItem.checked = true
        } else {
          sinItem.checked = false
        }
      })
      // 费用名称
      let findItem = this.finalDeliveryArray.find(item => { return item.checked })
      localStorage.setItem('deliveryService', findItem.deliveryService)
      localStorage.setItem('deliveryQuoteId', findItem.id)
      this.getGlobalDelivery()
    },
    /**
     * 监听是否选择最低派送方式
     * */
    watchChose() {
      if (!this.bestSendWay) {
        this.finalDeliveryArray.map(item => {
          item.checked = false
        })
        // 全置否时存空
        localStorage.setItem('deliveryService', '')
        localStorage.setItem('deliveryQuoteId', '')
        this.getGlobalDelivery()
      }
      // 自动选择最低派送方式
      localStorage.setItem('bestSendWay', this.bestSendWay)
    },
    // isShow(val) {
    //   return !(/(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,3})?$)/.test(val));
    // },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val
      this.getgoodsData()
    },
    Getdown() { //下载模板
      const checkDownloadType = localStorage.getItem('checkDownloadType') ? localStorage.getItem('checkDownloadType') : null
      let apiUrl = '/busFbx/downFBXBoxGoodsTemplate'
      if (this.isNewUpload) apiUrl = '/busFbx/downFBXBoxGoodsNewTemplate'
      if (checkDownloadType === 'A') apiUrl = '/busFbx/downAirBoxGoodsTemplate'
      this.axios
        // .get(`/busFbx/downFBXBoxGoodsTemplate`, {
        .get(apiUrl, {
          responseType: "arraybuffer" /* 一定要加这个 不然文件内容显示不了 */,
        })
        .then((res) => {
          // console.log(res)
          if (res.status) {
            let a = document.createElement("a");
            let blob = new Blob([res.data]);
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", `${this.$t('i18n_Product_Templates')}.xls`);
            a.click();
            URL.revokeObjectURL(objectUrl); // 释放内存
          } else {
          }
        })
        .catch((res) => { });
    },
    clickme(item) {
      console.log(item)
    },
    handleOPen(index) {
      console.log(index);
    },
    goodsEdit(index, item) {
      console.log(item)
      this.GoodsCategory = false;
      this.goodstextShow = true;
      this.addgoodform.customerid = JSON.parse(
        sessionStorage.getItem("Authorization")
      ).customerid; //客户id,
      this.addgoodform.brand = item.brand;
      this.addgoodform.declaredValue = item.declaredValue;
      this.addgoodform.goodstypeid = this.ThatgoodsID;
      this.addgoodform.hsCode = item.hsCode;
      this.addgoodform.materialc = item.materialc;
      this.addgoodform.materiale = item.materiale;
      this.addgoodform.namec = item.namec;
      this.addgoodform.namee = item.namee;
      this.addgoodform.purposec = item.purposec;
      this.addgoodform.purposee = item.purposee;
      this.addgoodform.sku = item.sku;
      this.addgoodform.id = item.id;
      this.addgoodform.isHasBattery = item.isHasBattery
      this.addgoodform.isPowderLiquid = item.isPowderLiquid
      this.addgoodform.goodstypeid = item.goodstypeid
      this.addgoodform.isHasMagnetism = item.isHasMagnetism
    },
    addgoodtext(formName) {
      if (this.addgoodform.namec == "") return this.$message(this.addPls("i18n_Product_name_in_Chinese", 'input'));
      if (this.addgoodform.namee == "") return this.$message(this.addPls("i18n_product_name_in_English", 'input'));
      if (this.addgoodform.goodstypeid == "") return this.$message(this.addPls("i18n_Product_Type", 'input'));
      if (!this.addgoodform.declaredValue && this.addgoodform.declaredValue !== 0) return this.$message("请输入货值");
      // if(+this.addgoodform.declaredValue<=0) return this.$message("货值必须大于0");
      // if (this.addgoodform.declaredValue <= 0) return this.$message("货值不能小于0");
      let params = {
        customerid: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id,
        brand: this.addgoodform.brand,
        declaredValue: this.addgoodform.declaredValue,
        goodstypeid: this.addgoodform.goodstypeid,
        hsCode: this.addgoodform.hsCode,
        materialc: this.addgoodform.materialc,
        materiale: this.addgoodform.materiale,
        namec: this.addgoodform.namec,
        namee: this.addgoodform.namee,
        purposec: this.addgoodform.purposec,
        purposee: this.addgoodform.purposee,
        sku: this.addgoodform.sku,
        id: this.addgoodform.id,
        isHasBattery: this.addgoodform.isHasBattery,
        isPowderLiquid: this.addgoodform.isPowderLiquid,
        isHasMagnetism: this.addgoodform.isHasMagnetism,
        productId: this.addgoodform.productId
      };
      this.axios
        .post(`/busFbx/addOrUpdateFbxCustomerGoodsCategory`, params)
        .then((res) => {
          if (res.data.code == "200") {
            this.goodstextShow = false;
            this.getgoodsData();
            this.$message({
              message: "成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.message,
              type: "info",
            });
          }
        })
        .catch((res) => { });
    },
    delGoodItem(index, item) {
      this.$confirm(this.$t("i18n_delete_goods_tip"), this.$t("i18n_hint"), {
        confirmButtonText: this.$t("i18n_confirm"),
        cancelButtonText: this.$t("i18n_cancel"),
        type: "warning",
      })
        .then(() => {
          let params = {
            id: item.id,
          };
          this.axios
            .post(
              `/busFbx/deleteFbxCustomerGoodsCategory`,
              qs.stringify(params)
            )
            .then((res) => {
              if (res.data.code == "200") {
                this.goodstextShow = false;
                this.getgoodsData();
              } else {
              }
            })
            .catch((res) => { });
          this.$message({
            type: "success",
            message: this.$t("i18n_Deleted_successfully"),
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("i18n_Canceled"),
          });
        });
    },
    changeGStype(id, index) {
      //切换货物类型
      this.getFBATrans(); //获取运输费
      this.getCheckGlobalDelivery();
      this.ruleform.formLIst[index].goodsDTOList = [];
      let typeName = "";
      this.goodstypelist.forEach((item) => {
        if (id == item.id) {
          typeName = item.cnName;
        }
      });
      this.ruleform.formLIst[index].typeName = typeName;
    },
    addgoods() {
      let productId = localStorage.getItem('checkProductId')
      //新增商品信息
      this.goodstextShow = true;
      this.GoodsCategory = true;
      this.addgoodform.id = "";
      this.addgoodform.brand = "";
      this.addgoodform.customerid = "";
      this.addgoodform.declaredValue = "";
      this.addgoodform.goodstypeid = "";
      this.addgoodform.hsCode = "";
      this.addgoodform.materialc = "";
      this.addgoodform.materiale = "";
      this.addgoodform.namec = "";
      this.addgoodform.namee = "";
      this.addgoodform.purposec = "";
      this.addgoodform.purposee = "";
      this.addgoodform.sku = "";
      this.addgoodform.isHasBattery = ''
      this.addgoodform.isPowderLiquid = ''
      this.addgoodform.isHasMagnetism = ''
      this.addgoodform.productId = productId
    },
    changegoods(index) {
      this.Sgodname = ''
      // if (!this.ruleform.formLIst[index].goodstypeid) return this.$message("请先选择商品类型");
      // this.ThatgoodsID = this.ruleform.formLIst[index].goodstypeid;
      this.thatindexgslist = []
      if (this.ruleform.formLIst[index].goodsDTOList.length > 0) { //if 当前箱子内有货物
        this.ruleform.formLIst[index].goodsDTOList.forEach(item => {
          this.thatindexgslist.push(item)
        })
      } else {
        this.thatindexgslist = []
      }
      console.log(this.thatindexgslist)
      this.BoxWrapindex = index;
      this.getgoodsData();
      this.goodsTypeShow = true;
    },
    handleSelectionChange(val) {
      this.thatGoodslist = val;
      console.log(val)
    },
    setGoodspush() {
      if (this.thatGoodslist.length == 0) return this.$message(this.addPls("i18n_Products", 'select'));
      let arr1 = JSON.parse(JSON.stringify(this.ruleform.formLIst[this.BoxWrapindex].goodsDTOList))
      this.thatGoodslist.forEach((item) => {
        arr1.push(item);
      });
      let newArr = [];
      arr1.forEach((el) => {
        const result = newArr.findIndex((ol) => {
          return el.id === ol.id;
        });
        if (result !== -1) {
          newArr[result].num = newArr[result].num + el.num;
        } else {
          newArr.push(el);
        }
      });

      if (this.fromFABck.country != this.toFABck.country) { //如果不是本地fba 则校验
        let newarray = this.thatindexgslist.concat(this.thatGoodslist)
        let idlist = []
        newarray.forEach(item => {
          idlist.push(item.goodstypeid)
        })
        idlist = [...new Set(idlist)]
        console.log(newarray)
        if (idlist.length > 1) return this.$message(this.$t("i18n_Only_same_type"));
        if (this.toFABck.countryCode == 'SA') {
          //2024/07/04 Jeffrey 取消单箱子内商品类型不能超过3个限制
          // if(newArr.length>3) return this.$message(this.$t("i18n_No_more_3_in_one_box"));
        }
      }

      //阿联酋电商发货限制
      let goodstypeids = []
      if (this.toFABck.countryCode == 'AE' && this.ruleform.formLIst != null) {
        this.ruleform.formLIst.forEach(item => {
          if (item.goodstypeid != "") {
            goodstypeids.push(item.goodstypeid)
          }
        })
        goodstypeids.push(newArr[0].goodstypeid)
        goodstypeids = [...new Set(goodstypeids)]
      }
      console.log(goodstypeids)
      if (goodstypeids.length > 1) return this.$message(this.$t("i18n_Image_manage1"));

      // 巴西电商订单校验：SKU、海关编码、中英文材质、中英文用途不能为空
      if (this.toFABck.countryCode == 'BR') {
        let hasEmptyField = false
        for (let i = 0; i < this.thatGoodslist.length; i++) {
          const item = this.thatGoodslist[i]
          if (!item.sku || !item.hsCode || !item.materialc || !item.materiale || !item.purposec || !item.purposee) {
            hasEmptyField = true
            break
          }
        }
        if (hasEmptyField) {
          if (this.lang === 'zh') {
            return this.$message.error('巴西电商订单 sku/海关编码/材质中英文/用途中英文 不能为空')
          } else {
            return this.$message.error('Brazil Order sku/customs code/material(chinese and english)/Upose(chinese and english) required.')
          }
        }
      }

      this.goodsTypeShow = false;
      newArr.forEach(item => {
        let isValid = isArray(item.goodsUrlList) && item.goodsUrlList.length;
        if (!isValid) item.goodsUrlList = [];
      })
      this.ruleform.formLIst[this.BoxWrapindex].goodsDTOList = newArr;
      this.ruleform.formLIst[this.BoxWrapindex].goodstypeid = newArr[0].goodstypeid
      this.ruleform.formLIst[this.BoxWrapindex].typeName = newArr[0].goodstype
      this.getFBATrans()
      this.getCheckGlobalDelivery()
    },
    getgoodsData(name) {
      //获取商品列表
      let params = {
        customerid: JSON.parse(sessionStorage.getItem("Authorization")).customerid, //客户id,
        goodstypeid: this.ThatgoodsID,
        goodTypeIds: localStorage.getItem("goodTypeIds"),
        name: name,
        towarehouseid: this.toFABck.id,
        pageNum: this.pageNum,
        pageSize: 10
      };
      this.axios
        .post(`/busFbx/getFbxCustomerGoodsCategoryList`, params)
        .then((res) => {
          if (res.data.code == "200") {
            console.log(res)
            res.data.data.list.forEach((item) => {
              this.$set(item, "num", 1);
            });
            this.goodsLabel = res.data.data.list;
            this.goodslisttotal = res.data.data.total
          } else {
          }
        })
        .catch((res) => { });
    },
    //-----------
    getGoodstypelist() {
      //商品类型
      let params = {
        warehouseId: this.toFABck.id,
      };
      this.axios
        .get(`/filedata/findFBAGoodTypeList?warehouseId=${this.toFABck.id}&goodTypeIds=${localStorage.getItem("goodTypeIds")}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.goodstypelist = res.data.datas;
          } else {

          }
        })
        .catch((res) => { });
    },
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    isSize(val) {
      val = val.replace(/[^0-9]/gi, "");
      return val;
    },
    isnumber(val) {
      val = val.replace(/\d+(\.\d{0,2})?/, "");
      return val;
    },

    changeTi() {
      this.THFdata.checked != this.THFdata.checked;
      if (this.THFdata.checked) {
        this.getTimoney();
      }
    },
    pathToNext(formName) {
      let PathCBM = 0
      let flag = true;
      let fromArr = this.ruleform.formLIst;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let File = true;
          try {
            fromArr.forEach((item, index) => {
              if (this.isGlobalDelivery && !this.isGlobalSea) {
                if (item.weight > 30) throw this.$message({ message: this.$t('i18n_weight_limit') });
                if (item.length > 120) throw this.$message({ message: this.$t('i18n_length_limit') });
                if (item.width > 120) throw this.$message({ message: this.$t('i18n_width_limit') });
                if (item.height > 120) throw this.$message({ message: this.$t('i18n_height_limit') });
              }
              item.cbm = (item.length * item.width * item.height) / 1000000;
              PathCBM += parseFloat(+item.cbm);
              if (item.goodsDTOList.length == 0) throw this.$message({ message: this.$t('i18n_add_product_in_box', { no: index + 1 }) });
              item.goodsDTOList.forEach(_item => {
                if (_item.num == 0 || _item.num == null) { throw this.$message({ message: this.$t('i18n_number_of_products_cannot_0') }); }
                if (!_item.declaredValue) throw this.$message({ message: this.addPls('i18n_product_value1', 'input') });
                if (_item.declaredValue <= 0) throw this.$message({ message: this.$t('i18n_product_value_bigger_0') });
                if (!(/(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,3})?$)/.test(_item.declaredValue))) throw this.$message({ message: this.$t('i18n_more_than0_two_decimal2') });
              })
            });
            const standardNameList = fromArr.map((standard) => standard.fbxBoxNo);
            if (new Set(standardNameList).size != standardNameList.length) {
              throw this.$message({ message: this.$t('i18n_duplicate_box_numbers') });
            }
          } catch (err) {
            File = false;
          }
          if (File) {
            let newArray = JSON.parse(JSON.stringify(this.ruleform.formLIst))

            if (this.billType && this.toFABck.countryCode == 'SA') {
              newArray.forEach((item, index) => {
                item.fbxBoxNo = item.fbxBoxNo.substr(0, 12)
              })
              for (var i = 0; i < newArray.length - 1; i++) {
                for (var j = i + 1; j < newArray.length; j++) {
                  if (newArray[i].fbxBoxNo === newArray[j].fbxBoxNo) {
                    // if (newArray[i].shopName !== newArray[j].shopName) return this.$message({
                    //   message: this.$createElement('p', null, [
                    //     this.$createElement('span', { style: 'color: #909399' }, `第`),
                    //     this.$createElement('i', { style: 'color: #E6A23C' }, `${i + 1}`),
                    //     this.$createElement('span', { style: 'color: #909399' }, `箱`),
                    //     this.$createElement('span', { style: 'color: #909399' }, `和`),
                    //     this.$createElement('span', { style: 'color: #909399' }, `第`),
                    //     this.$createElement('i', { style: 'color: #E6A23C' }, `${j + 1}`),
                    //     this.$createElement('span', { style: 'color: #909399' }, `箱PO号相同，请填写相同的`),
                    //     this.$createElement('span', { style: 'color: #F56C6C' }, '<商铺号>'),
                    //     this.$createElement('span', { style: 'color: #F56C6C' }, '<货件追踪号>')
                    //   ])
                    // });
                    if (newArray[i].poTrackingNo !== newArray[j].poTrackingNo) return this.$message({
                      message: this.$createElement('p', null, [
                        this.$createElement('span', { style: 'color: #909399' }, `第`),
                        this.$createElement('i', { style: 'color: #E6A23C' }, `${i + 1}`),
                        this.$createElement('span', { style: 'color: #909399' }, `箱`),
                        this.$createElement('span', { style: 'color: #909399' }, `和`),
                        this.$createElement('span', { style: 'color: #909399' }, `第`),
                        this.$createElement('i', { style: 'color: #E6A23C' }, `${j + 1}`),
                        this.$createElement('span', { style: 'color: #909399' }, `箱PO号相同，请填写相同的`),
                        // this.$createElement('span', { style: 'color: #F56C6C' }, '<商铺号>'),
                        this.$createElement('span', { style: 'color: #F56C6C' }, '<货件追踪号>')
                      ])
                    });
                  }
                }
              }
            }
            this.ruleform.formLIst.forEach((item, index) => { //计算单箱内得商品总数量
              let num = 0
              item.goodsDTOList.forEach(_item => {
                num += _item.num
              })
              item.goodsDTOnum = num
              item.boxNum = 1
            })
            localStorage.setItem("boxLIst", JSON.stringify(this.ruleform.formLIst)); //商品信息
            localStorage.setItem("THFdata", JSON.stringify(this.THFdata)); //提货费
            if (this.THFdata.checked) {
              if (!this.THFdata.amount) {
                return this.$message(this.$t("i18n_tiHuo_fee_exception"));
              }
            }
            if (this.FBATransmoney.amount == 0) {
              return this.$message(this.$t("i18n_fee_exception"));
            }
            localStorage.setItem("FBATransmoney", JSON.stringify(this.FBATransmoney)); //运输费
            localStorage.setItem("GlobalDelivery", JSON.stringify(this.GlobalDelivery)); //跨境运输费
            if (this.THFdata.checked) {//如果勾选了提货
              let params = {
                countryOrProvince: this.countLIst_T.parvince,
                fromWarehouseId: this.fromFABck.id,
              };
              if (!this.countLIst_T.parvince)
                return this.$message(this.$t("i18n_Please_select_pick_up_address"));
              if (this.todoorTime == null)
                return this.$message(this.$t("i18n_Please_choose_pick_up_time"));
              localStorage.setItem("todoorTime", this.todoorTime); //提货时间
              this.axios
                .post(`/busLcljobsBefore/validateDeliveryAddress`, qs.stringify(params))
                .then((res) => {
                  if (res.data.code == 200) {
                    this.$router.push({
                      name: "Fbaservice",
                      query: { PathCBM: PathCBM },
                    });
                    return
                  } else {
                    flag = false;
                    return this.$message({
                      message: res.data.message,
                    });
                  }
                })
                .catch((res) => { });
            } else {
              localStorage.removeItem("todoorTime");
              localStorage.removeItem("countLIst_T");
              this.$router.push({
                name: "Fbaservice",
                query: { PathCBM: PathCBM },
              });
            }
          }
        } else {
          flag = false;
          return false;
        }
      });
    },
    pathToback() {
      this.$router.go(-1);
    },
    getFBATrans() {
      //获取运输费
      this.loadin = true;
      let that = this;
      let boxDTOS = [];
      this.ruleform.formLIst.forEach((item, index) => {
        let goodItem = {
          goodsTypeId: 0,
          height: 0,
          length: 0,
          weight: 0,
          width: 0,
        };
        goodItem.goodsTypeId = item.goodstypeid;
        goodItem.height = item.height;
        goodItem.length = item.length;
        goodItem.width = item.width;
        goodItem.weight = item.weight;
        goodItem.sortNum = item.sortNum;
        boxDTOS.push(goodItem);
      });

      let params = {
        feeCode: "QBHYF",
        pollandId: JSON.parse(localStorage.getItem("fromFABck")).id, //起运地id,
        podlandId: JSON.parse(localStorage.getItem("toFABck")).id, //目的地仓库
        customerId: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id
        boxDTOS: boxDTOS,
        transportTypeCode: JSON.parse(localStorage.getItem("transportTypeCode")),
        productId: Number(localStorage.getItem("checkProductId"))
      };
      this.axios
        .post(`/FBAfee/getFBATransportFee`, params)
        .then((res) => {
          console.log(res)
          if (res.data.code == "200") {
            that.FBATransmoney.price = res.data.data.price;
            that.FBATransmoney.currency = res.data.data.currency;
            that.FBATransmoney.cnyprice = res.data.data.price;
            that.FBATransmoney.piece = 1;
            that.FBATransmoney.amount = res.data.data.amount;
            that.FBATransmoney.cnyamount = res.data.data.cnyamount;
            that.FBATransmoney.goodsTypeFeeDTOS =
              res.data.data.goodsTypeFeeDTOS;
          } else {
            that.FBATransmoney.cnyamount = 0;
            that.FBATransmoney.amount = 0;
            that.FBATransmoney.price = "";
            that.FBATransmoney.currency = "";
            that.FBATransmoney.cnyprice = "";
            that.FBATransmoney.goodsTypeFeeDTOS = [];
          }
        })
        .catch((res) => { });
    },
    getCheckGlobalDelivery() {
      // console.log('是否为跨境派送：', this.isGlobalDelivery)
      // if (this.isGlobalDelivery && !this.isGlobalSea) {
      //   // 计算尾程派送费
      //   await this.getFinalDelivery()
      //   // 计算派送费
      //   this.getGlobalDelivery();
      // }
    },
    /**
     * 计算尾程派送方式费用
     * */
    async getFinalDelivery() {
      console.log('是否为全境派送海运', this.$store)
      console.log('是否为全境派送海运', this.isAllSendSea)
      if (this.isGlobalSea) return
      this.loadin = true;
      let that = this;
      let boxDTOS = [];
      this.ruleform.formLIst.forEach((item, index) => {
        if (item.weight > 30) { return this.$message('重量限制30KG以内') }
        if (item.length > 120) { return this.$message('长度限制1.2M以内') }
        if (item.width > 120) { return this.$message('宽度限制1.2M以内') }
        if (item.height > 120) { return this.$message('高度限制1.2M以内') }
        let goodItem = {
          goodsTypeId: 0,
          height: 0,
          length: 0,
          weight: 0,
          width: 0,
        };
        goodItem.goodsTypeId = item.goodstypeid;
        goodItem.height = item.height;
        goodItem.length = item.length;
        goodItem.width = item.width;
        goodItem.weight = item.weight;
        goodItem.sortNum = item.sortNum;
        boxDTOS.push(goodItem);
      });


      let params = {
        pollandId: JSON.parse(localStorage.getItem("fromFABck")).id, //起运地id,
        podlandId: JSON.parse(localStorage.getItem("toFABck")).id, //目的地仓库
        customerId: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id
        productId: Number(localStorage.getItem("checkProductId")),
        countryId: Number(localStorage.getItem('toCountryId') || 0),
        transportTypeCode: JSON.parse(localStorage.getItem("transportTypeCode")),
        boxDTOS: boxDTOS
      };
      await this.axios
        .post(`/FBAfee/getGlobalDeliveryServiceList`, params)
        .then((res) => {
          console.log('尾程派送方式', res)
          if (Array.isArray(res.data.datas) && res.data.datas.length > 0 && Array.isArray(res.data.datas[0]) && res.data.datas[0].length > 0) {
            this.finalDeliveryArray = res.data.datas[0]
            this.finalDeliveryArray.map((item, index) => {
              this.$set(this.finalDeliveryArray, index, {
                ...item
              })
            })
            // 初始化缓存数据
            // 自动选择最低派送方式
            localStorage.setItem('bestSendWay', true)
            // 特殊逻辑返回页面时回显数据
            let getDeliveryQuoteId = localStorage.getItem('deliveryQuoteId')
            let getDeliveryService = localStorage.getItem('deliveryService')
            if (getDeliveryQuoteId && getDeliveryService) {
              this.finalDeliveryArray.map(item => { item.checked = false })
              this.finalDeliveryArray.find(item => { return item.id == getDeliveryQuoteId }).checked = true
            }
            // 费用名称
            let findItem = this.finalDeliveryArray.find(item => { return item.checked })
            localStorage.setItem('deliveryService', findItem.deliveryService)
            localStorage.setItem('deliveryQuoteId', findItem.id)
          } else {
            // 自动选择最低派送方式
            localStorage.setItem('bestSendWay', false)
            // 费用名称
            let findItem = this.finalDeliveryArray.find(item => { return item.checked })
            localStorage.setItem('deliveryService', findItem.deliveryService)
            localStorage.setItem('deliveryQuoteId', findItem.id)
            this.finalDeliveryArray = []
          }
        })
        .catch((res) => {
          this.finalDeliveryArray = []
        });
    },
    getGlobalDelivery() {
      //派送费
      this.loadin = true;
      let that = this;
      let boxDTOS = [];
      this.ruleform.formLIst.forEach((item, index) => {
        if (item.weight > 30) { return this.$message('重量限制30KG以内') }
        if (item.length > 120) { return this.$message('长度限制1.2M以内') }
        if (item.width > 120) { return this.$message('宽度限制1.2M以内') }
        if (item.height > 120) { return this.$message('高度限制1.2M以内') }
        let goodItem = {
          goodsTypeId: 0,
          height: 0,
          length: 0,
          weight: 0,
          width: 0,
        };
        goodItem.goodsTypeId = item.goodstypeid;
        goodItem.height = item.height;
        goodItem.length = item.length;
        goodItem.width = item.width;
        goodItem.weight = item.weight;
        goodItem.sortNum = item.sortNum;
        boxDTOS.push(goodItem);
      });

      let findItem = this.finalDeliveryArray.find(item => { return item.checked })
      let params = {
        pollandId: JSON.parse(localStorage.getItem("fromFABck")).id, //起运地id,
        podlandId: JSON.parse(localStorage.getItem("toFABck")).id, //目的地仓库
        customerId: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id
        productId: Number(localStorage.getItem("checkProductId")),
        countryId: Number(localStorage.getItem('toCountryId') || 0),
        transportTypeCode: JSON.parse(localStorage.getItem("transportTypeCode")),
        boxDTOS: boxDTOS,
        deliveryService: findItem ? findItem.deliveryService : '',
        bestSendWay: this.bestSendWay,
        deliveryQuoteId: findItem ? findItem.id : ''
      };
      this.axios
        .post(`/FBAfee/getGlobalDeliveryFee`, params)
        .then((res) => {

          if (res.data.code == "200") {
            that.GlobalDelivery.amount = res.data.data.amount;
            that.GlobalDelivery.cnyamount = res.data.data.cnyamount;
            that.GlobalDelivery.currency = res.data.data.currency;
            that.GlobalDelivery.piece = res.data.data.piece;
            that.GlobalDelivery.price = res.data.data.price;
            that.GlobalDelivery.calDesc = res.data.data.calDesc;
          } else {
            that.GlobalDelivery.amount = 0;
            that.GlobalDelivery.cnyamount = 0;
            that.GlobalDelivery.currency = "";
            that.GlobalDelivery.piece = "";
            that.GlobalDelivery.price = "";
            that.GlobalDelivery.calDesc = [];
          }
        })
        .catch((res) => { });
    },
    // 设为默认
    setDefault(item) {
      if (item.isdefault) {
        return this.$message.info(this.$t("i18n_Already_default_address"));
      }
      this.axios
        .post(`/customer/updateAddressDefault?addressId=${item.id}`, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.getPeopletable();
            this.$message.success(this.$t("i18n_Success"));
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => { });
    },
    getTimoney() {
      //获取提货费
      let that = this;
      let weight = 0,
        cbm = 0;
      this.ruleform.formLIst.forEach((item, index) => {
        item.cbm = (item.length * item.width * item.height) / 1000000;
        weight += parseFloat(+item.weight);
        cbm += parseFloat(+item.cbm);
      });
      let params = {};

      params = {
        province: this.countLIst_T.parvince, //省 name
        city: this.countLIst_T.city, //市 name
        area: this.countLIst_T.area, //区 name
        customerId: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id
        feeCode: "THF",
        inWarehouseId: JSON.parse(localStorage.getItem("fromFABck")).id,
        weight: weight,
        cbm: cbm,
      };
      this.axios
        .post(`/FBAfee/getFBAPickUpFee`, params)
        .then((res) => {
          console.log(res.data.data)
          if (res.data.code == "200") {
            if (res.data.data) {
              that.THFdata.price = res.data.data.price; //价格
              that.THFdata.currency = res.data.data.currency; //币种
              that.THFdata.cnyprice = res.data.data.cnyprice; //--隐藏单价
              that.THFdata.cnycurrency = res.data.data.cnycurrency; //”CNY”--换算币种
              that.THFdata.cnyamount = res.data.data.cnyprice; //”CNY”--换算币种
              that.THFdata.amount = res.data.data.price;
              that.THFdata.maxKilometer = res.data.data.maxKilometer
              that.THFdata.minKilometer = res.data.data.minKilometer
            } else {
              that.THFdata.price = null
              that.THFdata.currency = ''
              that.THFdata.cnyprice = null
              that.THFdata.amount = null
            }
          } else {
          }
        })
        .catch((res) => { });
    },
    clone(box) {
      this.$refs["ruleform"].validate((valid) => {
        let boxItem = JSON.parse(JSON.stringify(box));
        boxItem.fbxBoxNo = "";
        boxItem.sortNum = this.ruleform.formLIst.length + 1;
        if (valid) {
          this.ruleform.formLIst.push(JSON.parse(JSON.stringify(boxItem)));
          this.getTimoney(); //重新计算提货费
          this.getFBATrans(); //重新计算运输费
          this.getCheckGlobalDelivery(); //重新计算全境派送费
        } else {
          this.$message({
            type: "info",
            message: this.$t("i18n_Please_fill_box_information"),
          });
          return false;
        }
      });
    },
    DeleteTitem(index, row) {
      let that = this;
      this.$confirm(this.$t("i18n_Sure_delete"), this.$t("i18n_hint"), {
        confirmButtonText: this.$t("i18n_confirm"),
        cancelButtonText: this.$t("i18n_cancel"),
        type: "warning",
      })
        .then(() => {
          that.axios
            .post(`/customer/delAddress/${row.id}`)
            .then((res) => {
              if (res.data.code == "200") {
                that.$message({
                  message: res.data.message,
                  type: "success",
                });
                this.getPeopletable();
              } else {
                that.$message({
                  message: res.data.message,
                  type: "info",
                });
              }
            })
            .catch((res) => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("i18n_Canceled"),
          });
        });
    },
    addItem(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let File = true;
          try {
            this.ruleform.formLIst.forEach((item, index) => {
              console.log(item.goodsDTOList)
              if (item.goodsDTOList.length == 0) throw this.$message({ message: this.$t('i18n_add_product_in_box', { no: index + 1 }) });
              item.goodsDTOList.forEach(_item => {
                if (_item.num == 0 || _item.num == null) { throw this.$message({ message: this.$t('i18n_number_of_products_cannot_0') }); }
                if (!_item.declaredValue) throw this.$message({ message: `请添加商品货值` });
              })
            });
          } catch (err) {
            File = false;
          }
          if (File) {
            this.activeName = [];
            this.ruleform.formLIst.push({
              goodstypeid: "", //货物类型
              typeName: "",
              weight: "", //重量
              length: "", //长
              width: "", //宽
              height: "", //高
              shopName: "", //商户号
              poTrackingNo: "", //po追踪号
              fbxBoxNo: "", //箱号
              cbm: 0,
              sortNum: this.ruleform.formLIst.length + 1,
              goodsDTOList: [],
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    delBoxgood(index, _index) {
      //删除箱子内某个商品
      this.ruleform.formLIst[index].goodsDTOList.splice(_index, 1);
    },
    handleDelete(index) {
      //删除箱子信息
      this.$confirm(this.$t("i18n_Sure_delete"), this.$t("i18n_hint"), {
        confirmButtonText: this.$t("i18n_confirm"),
        cancelButtonText: this.$t("i18n_cancel"),
        type: "warning",
      })
        .then(() => {
          this.ruleform.formLIst.splice(index, 1);
          this.ruleform.formLIst.sort((a, b) => {
            return a.sortNum - b.sortNum
          })
          this.ruleform.formLIst.forEach((item, index) => {
            item.sortNum = index + 1;
          })
          // console.log('this.ruleform.formLIst',this.ruleform.formLIst)
          this.getFBATrans();
          this.getTimoney();
          this.getCheckGlobalDelivery();
          this.$message({
            type: "success",
            message: this.$t("i18n_Deleted_successfully"),
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("i18n_Canceled"),
          });
        });
    },
    getProvinces() {
      //获取国外地址
      let customerid = JSON.parse(sessionStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .post(`/filedata/findThirdLevelAddress`)
        .then((res) => {
          this.WaicountLIst = res.data.datas;
        })
        .catch((res) => { });
    },
    getPeopletable() {
      //获取提货联系人
      let that = this;
      let customerId = JSON.parse(sessionStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .get(`/customer/addressListForFBADelivery/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.tableData = res.data.datas;
            this.tempTableData = res.data.datas;
          } else {
          }
        })
        .catch((res) => { });
    },
    onScroll() {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height = document.getElementsByClassName("wrap_R")[0]
          .offsetHeight;
      }
      if (scrolled >= 200) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },

    // -------------------------弹窗地址-----------------------
    // jack methods start
    // 获取省市区列表
    // 关闭弹窗
    closeMyDialog() {
      if (this.edit) {
        this.$confirm(this.$t("i18n_status_is_edit_close"), this.$t("i18n_hint"), {
          confirmButtonText: this.$t("i18n_confirm"),
          cancelButtonText: this.$t("i18n_cancel"),
          type: "warning",
        })
          .then(() => {
            this.showMydialog = false;
            this.showAdd(false);
          })
          .catch((res) => { });
      } else {
        this.showMydialog = false;
      }
    },
    // 显示弹窗
    changeCheic(type) {
      this.getPeopletable(); //获取提货联系人
      this.showMydialog = true;
    },
    // 校验
    very() {
      if (!this.submitForm.name) {
        this.$message.info(this.cannotBeEmpty("i18n_contact_person"));
        return false;
      }
      if (!this.submitForm.tel) {
        this.$message.info(this.cannotBeEmpty("i18n_Phone_number"));
        return false;
      }
      // 城市
      if (!this.submitForm.city) {
        this.$message.info(this.cannotBeEmpty("i18n_contact_address"));
        return false;
      }
      // 区
      if (!this.submitForm.area) {
        this.$message.info(this.cannotBeEmpty("i18n_contact_address"));
        return false;
      }
      if (!this.submitForm.address) {
        this.$message.info(this.cannotBeEmpty("i18n_Detailed_address"));
        return false;
      }
      if (this.submitForm.tag) {
        if (this.submitForm.tag.length > 5) {
          this.$message.info(this.$t("i18n_label_cannot_exceeds_5_characters"));
          return false;
        }
      }

      return true;
    },
    // 显示新增
    showAdd(type) {
      if (type) {
        this.edit = true;
      } else {
        this.edit = false;
      }

      this.value = [];
      for (let key in this.submitForm) {
        this.submitForm[key] = "";
      }
    },
    handleChange(value) {
      this.submitForm.parvince = value[0];
      this.submitForm.city = value[1];
      this.submitForm.area = value[2];
    },
    // 模糊搜索
    searchNameOrPhone() {
      if (!this.nameOrPhone) {
        return this.getPeopletable();
      }
      let temp = [];
      this.tempTableData.forEach((item, index) => {
        if (
          item.name.indexOf(this.nameOrPhone) != -1 ||
          item.tel.indexOf(this.nameOrPhone) != -1
        ) {
          temp.push(item);
        }
      });
      this.tableData = temp;
    },
    addAddr(id) {
      if (!this.very()) {
        return;
      }
      if (!this.submitForm.id) {
        delete this.submitForm.id;
      }
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);
      // 新增
      this.submitForm.customerid = user.customerid;
      let path = "addOrUpdateDelivery";

      this.axios
        .post(`/customer/${path}`, this.submitForm, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.edit = false;
            this.value = [];
            this.getPeopletable();
            for (let key in this.submitForm) {
              this.submitForm[key] = "";
            }
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => { });
    },
    // 点击行
    rowClick(r) {
      this.countLIst_T = r;
      localStorage.setItem("countLIst_T", JSON.stringify(this.countLIst_T));
      this.showMydialog = false;
      this.getTimoney(); //重新计算提货费
    },
    //  edit
    getPopList() {
      // 获取省市区列表
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);
      this.axios
        .post(`/filedata/findDAndILevelAddress`, {}, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.jackCitylist = res.data.datas;
          } else {
            this.$message.info("服务器繁忙");
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        });
    },
    handleEdit(index, item) {
      this.value = [];
      let temp = JSON.stringify(item);
      this.submitForm = JSON.parse(temp);
      this.value.push(
        this.submitForm.parvince,
        this.submitForm.city,
        this.submitForm.area
      );
      this.edit = true;
    },
    //失败时的方法
    handleError(err) {
      this.$message.info(err.data);
    },
    //成功时的方法
    handleSuccess(response) {
      if (response.isSuccess) {
        this.$message.success(response.error);
        // this.getListByParam();
        return;
      }
      this.$message.info(response.error);
    },
    // 上传前
    // 现在兼容xls,xlsx文件，增加对xlsx的文件兼容
    handleBeforeUpload(file) {
      console.log(file)
      // 校验
      let legalName = ["xls"];
      let legalNameXlsx = ["xlsx"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name) || legalNameXlsx.includes(name)) {
        // console.log(legalName.includes(name));
      } else {
        this.$message.info(this.$t("i18n_xls_xlsx_files_only"));
        return false;
      }
    },
    //上传
    uploadSectionFile(params) {
      let form = new FormData()
      form.append('file', params.file)
      let url = '/busFbx/uploadFbxJobsBoxInfo/'
      let productId = localStorage.getItem('checkProductId')
      if (this.isNewUpload) url = '/busFbx/uploadFbxJobsBoxNewInfo/'
      this.axios.post(`${url}${this.toFABck.id}/${this.transportTypeCode}/${productId}`, form)
        .then((res) => {
          console.log(res)
          if (res.data.code == -1) {
            this.errorLabel = res.data.data
            this.$message.info(res.data.data);
          } else if (res.data.code == 500) {
            this.$message.info(res.data.message);
          } else {
            // console.log('123==',res)
            this.ruleform.formLIst = res.data.data
            this.excelVisible = false
            this.getTimoney(); //重新计算提货费
            this.getFBATrans(); //重新计算运输费
            this.getCheckGlobalDelivery(); //重新计算全境派送
          }
        }).catch((res) => {
          console.log(res);
        });
    },
    beforeImgUpload(file) {
      // 校验
      let legalName = ["jpg", "jpeg", "png"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
        // console.log(legalName.includes(name));
      } else {
        this.$message.info(`仅能上传${legalName.join(',')}格式的图片`);
        return false;
      }
    },
    imgUpload(params) {
      let form = new FormData()
      form.append('file', params.file)
      this.axios.post('/busFbx/uploadGoodsPic', form)
        .then(res => {
          if (res.data.code === 200) {
            this.getGoodsPicUrl(res.data.message)
            this.$message.success('上传成功')
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
    getGoodsPicUrl(path) {
      this.axios.post('/busFbx/previewGoodsPic', qs.stringify({ picUrl: path }))
        .then(res => {
          this.ruleform.formLIst[this.boxIndex].goodsDTOList[this.goodIndex].goodsUrl = res.data.message
        })
    },
    picUpload(index1, index2) {
      this.boxIndex = index1
      this.goodIndex = index2
    },
    addPls,
    cannotBeEmpty,
    /**
     * 显示图片管理
     */
    showPictureManage(boxIndex, goodsIndex) {
      this.boxIndex = boxIndex;
      this.goodIndex = goodsIndex;
      let boxItem = this.ruleform.formLIst[boxIndex];
      let goodsItem = boxItem.goodsDTOList[goodsIndex];
      let pictureFullList = goodsItem.goodsUrlList || [];
      if (pictureFullList.length) pictureFullList = [].concat(pictureFullList);
      let imgNameList = [];
      this.pictureFullList = pictureFullList;
      this.fileList = pictureFullList.map((item, index) => {
        let name = `image${index}`;
        imgNameList.push(name);
        return {
          name: name,
          url: item,
        }
      });
      this.imgNameList = imgNameList;
      this.pictureManage = true;
    },
    /**
     * 隐藏图片管理
     */
    uploadDialogClose() {
      this.pictureManage = false;
    },
    handleClose() {
      if (this.$refs.pictureManage && this.$refs.pictureManage.clearFiles) this.$refs.pictureManage.clearFiles();
      this.pictureFullList = [];
      this.fileList = [];
      this.imgNameList = [];
      this.boxIndex = 0;
      this.goodIndex = 0;
    },
    /**
     * 图片管理 上传
     * @param params
     */
    uploadPicture(params) {
      let form = new FormData()
      form.append('file', params.file)
      this.sendUploadSinglePicture(form)
        .then(res => {
          if (!res.message) return Promise.reject(Error("上传图片后未返回存储路径"));
          return this.getPictureFullUrl(res.message);
        })
        .then(res => {
          if (!res.message) return Promise.reject(Error("获取上传图片的访问路径异常"));
          this.imgNameList.push(params.file.name);
          this.pictureFullList.push(res.message);
          this.$message.success("上传成功");
        })
        .catch(res => {
          console.error(res);
          this.$message.error(`上传图片：${res.message || "网络异常，请稍后再试"}`);
          return Promise.reject(res);
        })
    },
    /**
     * 上传一张图片,返回相对（短）路径
     * @param formData
     * @returns {Promise<AxiosResponse<any>>}
     */
    sendUploadSinglePicture(formData) {
      return this.axios.post('/busFbx/uploadGoodsPic', formData)
        .then(res => {
          res = isObject(res.data) ? res.data : {};
          if (res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
    },
    /**
     * 根据上传接口返回的 path获取图片存储的完整url
     * @param relativePath
     * @returns {Promise<AxiosResponse<any>>}
     */
    getPictureFullUrl(relativePath) {
      let url = '/busFbx/previewGoodsPic';
      let data = { picUrl: relativePath };
      return this.axios.post(url, qs.stringify(data))
        .then(res => {
          res = isObject(res.data) ? res.data : {};
          if (res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
    },
    /**
     * 图片管理 文件状态改变
     * @param params
     */
    handleUploadError(file, fileList) {
      console.log("change", file, fileList)
    },
    /**
     * 图片管理 文件列表移除文件时
     * @param params
     */
    handleUploadRemove(file, fileList) {
      const index = this.imgNameList.findIndex(item => item === file.name);
      if (index >= 0) {
        this.pictureFullList.splice(index, 1);
        this.imgNameList.splice(index, 1);
      }
    },
    /**
     * 图片管理 点击文件列表中已上传的文件时
     * @param params
     */
    handlePictureCardPreview(file) {
      this.previewUrl = file.url;
      this.previewVisible = true;
    },
    /**
     * 图片管理 点击确认
     */
    clickSavePictureManage() {
      let boxItem = this.ruleform.formLIst[this.boxIndex];
      let goodsItem = boxItem.goodsDTOList[this.goodIndex];
      let pictureFullList = [].concat(this.pictureFullList);
      goodsItem.goodsUrlList = pictureFullList;
      this.pictureManage = false;
    }
  },
  created() {
    this.transportTypeCode = JSON.parse(localStorage.getItem("transportTypeCode"))
    if (localStorage.getItem("FBATransmoney")) {
      //提货地址
      this.FBATransmoney = JSON.parse(localStorage.getItem("FBATransmoney"));
    }
    if (localStorage.getItem("GlobalDelivery")) {
      //跨境运输费
      this.GlobalDelivery = JSON.parse(localStorage.getItem("GlobalDelivery"));
    }
    if (localStorage.getItem("isGlobalDelivery")) {
      this.isGlobalDelivery = JSON.parse(localStorage.getItem("isGlobalDelivery"));
    }
    // 是否为全境派送海运
    this.isGlobalSea = this.$store.state.productInfo.transportTypeCode == 'HY' && this.$store.state.productInfo.isGlobalDelivery
    console.log("是否为全境派送海运", this.isGlobalSea)
    if (localStorage.getItem("countLIst_T")) {
      //提货地址
      this.countLIst_T = JSON.parse(localStorage.getItem("countLIst_T"));
    }
    if (localStorage.getItem("todoorTime")) {
      //提货时间
      this.todoorTime = localStorage.getItem("todoorTime");
    }
    if (localStorage.getItem("boxLIst")) {
      //箱子
      this.ruleform.formLIst = JSON.parse(localStorage.getItem("boxLIst"));
    }
    if (localStorage.getItem("THFdata")) {
      // 提货费
      this.THFdata = JSON.parse(localStorage.getItem("THFdata"));
    }
  },
  mounted() {
    this.getGoodstypelist();
    this.getPopList();
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll);
      if (this.isGlobalDelivery) {
        // 页面切换回显数据
        let getDeliveryQuoteId = localStorage.getItem('deliveryQuoteId')
        let getDeliveryService = localStorage.getItem('deliveryService')
        if (getDeliveryQuoteId && getDeliveryService) {
          // this.getFinalDelivery()
        }

      }
    });
    let toFABck = JSON.parse(localStorage.getItem("toFABck"));
    if (toFABck.type == 1) {
      this.maxlength = 19
    } else {
      this.maxlength = 99
    }
    if (toFABck.type == 1 && toFABck.countryCode == 'SA') { //需要校验
      this.billType = true //显示 商铺号和追踪号
      this.moreNotOjb.Notponum[0].required = true;
      this.moreNotOjb.Notgoodsnum[0].required = true;
      this.moreNotOjb.Notboxnum[0].required = true;
    } else if (toFABck.type == 1 && toFABck.countryCode != 'SA') {
      this.billType = true
      this.moreNotOjb.Notponum[0].required = false; //追踪号
      this.moreNotOjb.Notgoodsnum[0].required = false; //商铺号
      this.moreNotOjb.Notboxnum[0].required = true; //箱号校验
    }
    // this.billType = false
    // this.moreNotOjb.Notponum[0].required = false;
    // this.moreNotOjb.Notgoodsnum[0].required = false;
  },
};
</script>
<style scoped>
.box-card {
  position: relative;
}
.cardWrap {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  margin-top: 20px;
  border-radius: 8px;
}
.card_header {
  padding: 10px 20px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 2px solid transparent;
  /* background: linear-gradient(white,white) padding-box,repeating-linear-gradient(-45deg, red 0, red 12.5%, transparent 0, transparent 25%, #58a 0, #5F4AFF 37.5%, transparent 0, transparent 50%) 0/5em 5em; */
  /* border-bottom: 1px solid #DCDFE6; */
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.card_count {
  padding: 20px 20px 0 20px;
}
.addStyle {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  box-sizing: border-box;
}
.header_logo {
  height: 30px;
  line-height: 30px;
  margin-left: 4px;
  color: #fff;
  position: absolute;
  top: 11px;
  right: 0px;
  border-radius: 20px 0px 0px 20px;
  background: #5ab53c;
  font-weight: bold;
  border-style: none none solid solid;
  /* border-color: #83a4fe;
  border-width: 3px; */
  z-index: 999;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
}
.boxindex {
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #51ddd4;
  text-align: center;
  top: 16px;
  left: 4px;
  color: #ffffff;
  line-height: 16px;
  font-size: 12px;
  text-align: center;
}
.cloneType {
  color: #ffffff;
  float: left;
}
.deletebox {
  width: 60px;
  height: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  border-radius: 0 20px 20px 0;
  background: #51ddd4;
  font-weight: bold;
  border-style: solid solid none none;
  border-color: #f86670;
  border-width: 3px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
}
.deleteBtn {
  cursor: pointer;
  transition: all 0.2s ease-out;
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
  margin-left: 15px;
}
.TB_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.fontString {
  font-weight: bold;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 900px;
}
.goodsValue >>> .el-input__inner {
  border-radius: 0 !important;
  height: 24px !important;
  width: 100% !important;
  text-align: center;
  border: none;
  border-bottom: 1px solid #9999;
}
.handNumber {
  position: relative;
}
.numName {
  position: absolute;
  left: -45px;
  top: 0;
}
.handNumber >>> .el-input__inner {
  border-radius: 20px !important;
  height: 24px !important;
  width: 100px !important;
  text-align: center;
}
/* 去除 number类型 的自带默认箭头 */
.handNumber >>> .el-input__inner::-webkit-outer-spin-button,
.handNumber >>> .el-input__inner::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.handNumber >>> .el-input__inner[type="number"] {
  -moz-appearance: textfield;
}
.goodsTypeShow >>> .el-dialog__body {
  padding: 0 !important;
}
.table_wrap >>> .el-dialog__body {
  padding: 0 15px !important;
}
.card_header >>> .el-form-item {
  margin-bottom: 0px !important;
}
.Item_Right {
  float: left;
}
.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}
.goodLi {
  width: 100%;
  height: 30px;
  padding: 0px;
  display: flex;
  align-items: center;
}
.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.Iteminput {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 15px;
  color: #909399;
}
.center_wrap {
  width: 1280px;
  margin: 0 auto;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 24px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.send_end {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 20px;
  border: 1px solid #e7e7e7;
  padding-left: 20px;
  border-top: none;
  border-radius: 0 0 10px 10px;
}
.send_end_content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.send_content_item,
.send_content_secItem {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 400px;
  height: 40px;
}
.send_item_left {
  font-weight: bold;
}
.send_content_secItem .send_item_left {
  flex: 1;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 0 20px;
  border-radius: 5px;
}
.send_content_secItem .send_left_one {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}
.send_content_secItem .send_item_right {
  width: 40px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.wrap_l {
  float: left;
  width: 875px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 0 35px;
  box-sizing: border-box;
}
.wrap_R {
  float: right;
  width: 380px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  /* position: sticky;
  top: 0px; */
}
.cangkutit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  float: left;
}
/* jack css start  */
/* 弹窗遮罩层 */
.dialogCover {
  width: 100%;
  height: 100%;
  background-color: rgba(88, 85, 85, 0.37);
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
}
/* 弹窗 */
.myDialog {
  min-height: 350px;
  width: 50%;
  height: 50%;
  min-height: 400px;
  width: 50%;
  height: 50%;
  background-color: #fff;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
  border-radius: 20px;
  padding: 20px;

  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
}
/* 进一步查价 */
.redBtn {
  width: 159px;
  /* margin-top: 30px; */
  line-height: 53px;
  height: 53px;
  text-align: center;
  background: linear-gradient(-56deg, #ff3b2c 0%, #ff6a6a 100%);
  border-radius: 10px;
  color: #ffffff;
  cursor: pointer;
}
/* jack css end  */
/deep/.el-table .cell {
  word-break: break-word;
}
/* .upload-img >>> .el-upload-list {
  display: none;
} */
.upload-img {
  margin-right: 20px;
}

/* 货值统计 */
.goodsValueCount {
  box-sizing: border-box;
  width: 100%;
  float: left;
  padding-top: 10px;
  color: #f86670;
}
.goodsValue_fat {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 10px;
}
.goodsValue_name {
  font-size: 14px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/FBAorder/FbaCargo.vue